export default {
  none: "არცერთი",
  badge: {
    new: "ახალი",
  },
  contextTag: {
    add: "ტეგის დამატება",
  },
  nav: {
    menu: "მენიუ",
    mainNav: "ნავიგაცია",
    home: "მთავარი",
    dashboard: "ანალიტიკა",
    orders: "შეკვეთები",
    products: "პროდუქტები",
    archive: "არქივი",
    settings: "პარამეტრები",
    language: "ენა",
    theme: "თემა",
    more: "მეტი",
    fullscreen: "სრული ეკრანი",
    exitFullscreen: "სრული ეკრანიდან გასვლა",
    workspaces: "სამუშაო სივრცეები",
    configuration: "კონფიგურაცია",
    personalSettings: "პირადი პარამეტრები",
    systemConfig: "კონფიგურაცია",
    deliverySessions: "მიტანის სესიები",
    delivery: "მიტანა",
    showGuide: "დახმარება",
    customers: "მომხმარებლები",
  },
  settings: {
    title: "პარამეტრები",
    pageDescription: "სამუშაო სივრცის პარამეტრების კონფიგურაცია",
    contextTags: "კონტექსტის ტეგები",
    contextTagsDescription:
      "განსაზღვრეთ საკუთარი ტეგები შეკვეთების კლასიფიკაციისთვის (მაგ., შეკეთება, გაცვლა, გატანა). ეს დაგეხმარებათ შეკვეთების ორგანიზებაში მიტანის პროცესზე გავლენის გარეშე.",
    addContextPlaceholder: "დაამატეთ კონტექსტი (მაგ., შეკეთება)",
    contextsUsed: "კონტექსტი გამოყენებული",
    noContexts: "კონტექსტის ტეგები არ არის განსაზღვრული",
    addFirstContext: "დაამატეთ თქვენი პირველი კონტექსტის ტეგი ზემოთ",
    saved: "პარამეტრები შენახულია",
    saveFailed: "პარამეტრები ვერ შეინახა. სცადეთ ხელახლა.",
    saveChanges: "ცვლილებების შენახვა",
    noChanges: "შეუნახავი ცვლილებები არ არის",
    maxContextsReached: "მაქსიმუმ 7 კონტექსტია დაშვებული",
    duplicateContext: "ეს კონტექსტი უკვე არსებობს",
    courierQuickActions: "კურიერის სწრაფი მოქმედებები",
    courierQuickActionsDescription:
      "მოქმედებები, რომლებიც კურიერებს შეუძლიათ გამოიყენონ ახალი შეკვეთების შესაქმნელად მიტანის დროს (მაგ., დაბრუნება, შეკეთება)",
    addActionPlaceholder: "დაამატეთ მოქმედება (მაგ., დაბრუნება)",
    actionsUsed: "მოქმედება კონფიგურირებული",
    actionsEnabled: "მოქმედება ჩართული",
    noActions: "სწრაფი მოქმედებები არ არის კონფიგურირებული",
    addFirstAction: "დაამატეთ თქვენი პირველი სწრაფი მოქმედება ზემოთ",
    maxActionsReached: "მაქსიმუმ 10 მოქმედებაა დაშვებული",
    duplicateAction: "ეს მოქმედება უკვე არსებობს",
    enableAction: "მოქმედების ჩართვა",
    disableAction: "მოქმედების გამორთვა",
    defaultContexts: ["შეკეთება", "გაცვლა", "გატანა", "დოკუმენტები", "საჩუქარი", "გადახდა ადგილზე", "პრიორიტეტული"],
    defaultActions: ["შეკეთება", "დაბრუნება", "ცარიელი კარტრიჯი", "დამატებითი შეკვეთა"],
    externalOrder: {
      title: "გარე შეკვეთების მიღება",
      description:
        "მიიღეთ კლიენტების შეკვეთები საჯარო ბმულის მეშვეობით. კლიენტებს შეუძლიათ შეკვეთების გაკეთება ავტორიზაციის გარეშე.",
      productMode: "პროდუქტის არჩევა",
      selectFromProducts: "პროდუქტების არჩევა",
      customProduct: "ხელით შეყვანა",
      selectProduct: "აირჩიეთ პროდუქტი",
      noProducts: "პროდუქტები არ არის",
      productName: "პროდუქტის სახელი",
      productNamePlaceholder: "მაგ. ახალი კვერცხი",
      productPrice: "ფასი ერთეულზე (₾)",
      productPricePlaceholder: "მაგ. 0.50",
      productUnit: "ერთეული",
      category: "შეკვეთის კატეგორია",
      selectCategory: "აირჩიეთ კატეგორია",
      publicLink: "საჯარო შეკვეთის ბმული",
      linkCopied: "ბმული დაკოპირდა!",
      regenerateLink: "ბმულის განახლება",
      regenerateConfirm: "დარწმუნებული ხართ რომ გსურთ ახალი ბმულის გენერირება? ძველი ბმული აღარ იმუშავებს.",
      linkProtectedHint: "ეს ბმული მუდმივია. განახლების ღილაკი გამოიყენეთ მხოლოდ ახალი URL-ის საჭიროების შემთხვევაში.",
      businessPhone: "ბიზნეს ტელეფონი",
      businessPhoneHint: "ნაჩვენებია კლიენტებისთვის კითხვების შემთხვევაში",
      deliveryNote: "მიტანის შენიშვნა",
      deliveryNotePlaceholder: "მაგ. თბილისში მიტანა უფასოა",
      minQuantity: "მინიმალური რაოდენობა",
      save: "შენახვა",
      selectProductFirst: "შეიყვანეთ პროდუქტის სახელი და ფასი",
    },
    orderId: {
      title: "შეკვეთის ID ფორმატი",
      description: "დააკონფიგურირეთ შეკვეთის ნომრების ავტომატური გენერირება",
      mode: "გენერირების რეჟიმი",
      unifiedFormat: "ერთიანი ფორმატი (ყველასთვის ერთნაირი)",
      perSourceFormat: "წყაროს მიხედვით პრეფიქსები",
      prefix: "პრეფიქსი",
      separator: "გამყოფი",
      noSeparator: "არცერთი",
      dateFormat: "თარიღის ფორმატი",
      noDate: "თარიღის გარეშე",
      sequenceLength: "თანმიმდევრობის სიგრძე",
      digits: "ციფრი",
      preview: "გადახედვა",
      sourcePrefixes: "წყაროს პრეფიქსები",
      manualPrefix: "ხელით",
      externalPrefix: "გარე",
      aiPrefix: "AI/სმარტ",
      courierPrefix: "კურიერი",
      autoGenerateHint: "დატოვეთ შეკვეთის ნომერი ცარიელი ავტომატური გენერირებისთვის",
    },
    dashboardPreferences: "დაფის პარამეტრები",
    showLivePulse: "აქტივობის კონსოლის ჩვენება",
    showLivePulseDesc: "რეალურ დროში შეკვეთების აქტივობა მისალმების ქვემოთ",
    enablePulseSound: "კრიტიკული მოვლენების სიგნალი",
    enablePulseSoundDesc: "ხმოვანი სიგნალი მიტანის წარუმატებლობის ან უარყოფის შემთხვევაში",
    autoArchive: {
      title: "შესრულებული შეკვეთების ავტო-დაარქივება",
      description: "მიწოდებული და გაუქმებული შეკვეთები ავტომატურად გადავა არქივში.",
      off: "გამორთული",
      after30: "30 დღის შემდეგ",
      after60: "60 დღის შემდეგ",
      after90: "90 დღის შემდეგ",
    },
    appInstallation: {
      title: "აპლიკაციის ინსტალაცია",
      description: "დააინსტალირეთ OrderFlow როგორც აპლიკაცია უფრო სწრაფი წვდომისა და ოფლაინ მხარდაჭერისთვის",
      statusInstalled: "უკვე დაინსტალირებულია",
      statusNotInstalled: "არ არის დაინსტალირებული",
      statusCanInstall: "მზადაა ინსტალაციისთვის",
      installButton: "ინსტალაცია",
      installButtonLong: "აპის ინსტალაცია",
      iosTitle: "ინსტალაცია iOS-ზე",
      iosStep1: "დააჭირეთ გაზიარების ღილაკს (□↑) Safari-ს ქვედა ნაწილში",
      iosStep2: 'გადაახვიეთ ქვემოთ და დააჭირეთ "დაამატე მთავარ ეკრანზე"',
      iosStep3: 'დააჭირეთ "დამატება" ზედა მარჯვენა კუთხეში',
      androidTitle: "ინსტალაცია Android-ზე",
      androidStep1: "დააჭირეთ მენიუს ღილაკს (⋮) თქვენს ბრაუზერში",
      androidStep2: 'დააჭირეთ "დაამატე მთავარ ეკრანზე" ან "აპის ინსტალაცია"',
      androidStep3: 'დააჭირეთ "დამატება" დასადასტურებლად',
      desktopTitle: "აპის ინსტალაცია",
      desktopStep1: "დააჭირეთ ინსტალაციის ხატულას (⊕) ბრაუზერის მისამართის ზოლში",
      desktopStep2: 'ან დააჭირეთ მენიუს (⋮) და აირჩიეთ "OrderFlow-ის ინსტალაცია"',
      desktopStep3: "მიჰყევით მითითებებს ინსტალაციის დასასრულებლად",
    },
    branding: {
      title: "საჯარო გვერდის იერსახე",
      description: "მოარგეთ თქვენი საჯარო შეკვეთის გვერდი ბრენდის ამოცნობისთვის",
      logo: "ლოგო",
      logoHint: "ნაჩვენებია თქვენი საჯარო გვერდის სათაურში",
      uploadLogo: "ლოგოს ატვირთვა",
      replaceLogo: "შეცვლა",
      removeLogo: "წაშლა",
      brandColor: "ბრენდის ფერი",
      brandColorHint: "გამოიყენება ღილაკებსა და აქცენტებზე საჯარო გვერდზე",
      tagline: "სლოგანი",
      taglinePlaceholder: "მაგ. ბუნებრივი მთის თაფლი მეორე დღეს მიტანით",
      taglineHint: "მოკლე შეტყობინება ბიზნესის სახელის ქვეშ",
      introText: "ბიზნესის შესახებ",
      introTextPlaceholder: "მაგ. ჩვენ ვაწარმოებთ ბუნებრივ თაფლს აჭარის ტყეებიდან. დღეს გაკეთებული შეკვეთები ხვალ მიგეწოდებათ.",
      introTextHint: "მოკლე აღწერა, რომელიც ნაჩვენებია მომხმარებლებისთვის",
      contactLinks: "საკონტაქტო ბმულები",
      contactLinksHint: "მომხმარებლებს შეუძლიათ სხვა არხებით დაგიკავშირდნენ",
      addLink: "ბმულის დამატება",
      removeLink: "წაშლა",
      linkType: "ტიპი",
      linkValue: "ბმული / ნომერი",
      phone: "ტელეფონი",
      messenger: "მესენჯერი",
      instagram: "Instagram",
      facebook: "Facebook",
      maxLinks: "მაქსიმუმ 4 საკონტაქტო ბმული",
      charsRemaining: "სიმბოლო დარჩენილი",
    },
  },
  livePulse: {
    newOrder: "ახალი შეკვეთა მიღებულია",
    statusChange: "→ {{status}}",
    acknowledged: "დადასტურებულია",
    cantTake: "ვერ მიიღებს",
    deliveryFailed: "მიწოდება ვერ შესრულდა",
    delivered: "მიწოდებულია",
    received: "მიღებულია",
    created: "შექმნილია",
    waitingForActivity: "აქტივობის მოლოდინში...",
    statusNew: "→ ახალი",
    statusProcessing: "→ მუშავდება",
    statusReady: "→ მზადაა",
    statusOutForDelivery: "→ მიტანის გზაზე",
    statusCancelled: "→ გაუქმებული",
    statusAwaitingPayment: "→ გადახდის მოლოდინში",
    outForDelivery: "გზაშია",
    addressUpdated: "მისამართი განახლდა",
    assignedToSession: "მიენიჭა მიტანის სესიას",
    removedFromSession: "წაიშალა სესიიდან",
    paymentReceived: "გადახდა მიღებულია",
    orderReceived: "შეკვეთა მიღებულია",
    orderEdited: "შეკვეთის დეტალები განახლდა",
    retryDelivery: "ხელახალი მიტანა დაიწყო",
  },
  readiness: {
    prepared: "შეკვეთები მზადაა",
    needsAction: "შეკვეთები მზადდება",
    preparedTooltip: "ყველა შეკვეთა გამზადებულია და გადაცემულია კურიერს.",
    needsActionPrefix: "შეამოწმე",
    // Status-based labels (not acknowledgement-based)
    preparationLabel: "მოსამზადებელი",
    dispatchLabel: "მზა შეკვეთები კურიერის გარეშე",
    issuesLabel: "მიტანისას წარმოიშვვა პრობლემა",
  },
  roles: {
    manager: "მენეჯერი",
    courier: "კურიერი",
    system: "სისტემა",
  },
  theme: {
    switchToDark: "მუქ რეჟიმზე გადართვა",
    switchToLight: "ნათელ რეჟიმზე გადართვა",
    eveningActive: "საღამოს სითბო აქტიურია ☀️→🌙",
    nightModeAuto: "ღამის რეჟიმი (თვალების დასაცავად)",
    nightModeOverride: "ნათელ რეჟიმზე გადახვედით - დააჭირეთ მუქზე დასაბრუნებლად",
  },
  fullscreen: {
    enter: "სრული ეკრანი",
    exit: "სრული ეკრანიდან გამოსვლა",
    addToHomeScreen: "სრული ეკრანისთვის დაამატეთ მთავარ ეკრანზე",
  },
  notifications: {
    title: "შეტყობინებები",
    markAllRead: "ყველას წაკითხვა",
    empty: "აქტივობა ჯერ არ არის",
    soundOn: "ხმის ჩართვა",
    soundOff: "ხმის გამორთვა",
    rollingWindow: "ბოლო 2 დღის აქტივობა",
  },
  recentActivity: {
    title: "ბოლო აქტივობა",
    seeAll: "ყველას ნახვა",
    empty: "აქტივობა ჯერ არ არის",
    today: "დღეს",
    yesterday: "გუშინ",
    earlier: "ადრე",
    rollingWindow: "ბოლო 2 დღის აქტივობა",
  },
  common: {
    back: "უკან",
    signOut: "გამოსვლა",
    dashboard: "ანალიტიკა",
    loading: "იტვირთება...",
    save: "შენახვა",
    retrySave: "ხელახლა შენახვა",
    offlineBanner: "ინტერნეტ კავშირი გათიშულია — ცვლილებები არ შეინახება კავშირის აღდგენამდე.",
    cancel: "გაუქმება",
    delete: "წაშლა",
    edit: "რედაქტირება",
    view: "ნახვა",
    search: "ძიება",
    filter: "ფილტრი",
    export: "ექსპორტი",
    add: "დამატება",
    all: "ყველა",
    yes: "დიახ",
    no: "არა",
    close: "დახურვა",
    confirm: "დადასტურება",
    at: "დროს",
    from: "დან",
    to: "მდე",
    of: "დან",
    next: "შემდეგი",
    success: "წარმატება",
    error: "შეცდომა",
    more: "მეტი",
    none: "არცერთი",
    saving: "ინახება...",
    disabled: "გამორთული",
    actions: "მოქმედებები",
    order: "შეკვეთა",
    orders: "შეკვეთა",
    update: "განახლება",
    showLess: "ნაკლების ჩვენება",
    discardChanges: {
      title: "ცვლილებების გაუქმება?",
      description: "თქვენ გაქვთ შეუნახავი ცვლილებები, რომლებიც დაიკარგება.",
      keepEditing: "რედაქტირების გაგრძელება",
      discard: "გაუქმება",
    },
  },
  session: {
    column: "მიტანა",
    unassigned: "დაუნიშნავი",
    noActiveSessions: "აქტიური მიტანები არ არის",
    notReadyTooltip: "შეკვეთა უნდა იყოს მზად მიტანამდე",
    lockedTooltip: "შეკვეთა მიმაგრებულია ამ მიტანაზე",
    assignToSession: "მიტანაზე მიმაგრება",
    unassign: "მოხსნა",
    confirmReassign: {
      title: "შეკვეთის გადანიშვნა",
      description: "აირჩიეთ მიტანა შეკვეთის მინიჭებისთვის",
      confirm: "გადანიშვნა",
    },
    assignSuccess: "შეკვეთა მიენიჭა მიტანას",
    unassignSuccess: "შეკვეთა მოიხსნა მიტანიდან",
    errors: {
      locked: "შეკვეთა დაბლოკილია — უკვე მიტანილად მონიშნულია აქტიურ სესიაში",
      sessionInactive: "ეს მიტანის სესია არ არის აქტიური",
      sessionExpired: "ეს მიტანის სესია ვადაგასულია",
      sessionNotFound: "მიტანის სესია ვერ მოიძებნა",
      orderNotReady: "შეკვეთა უნდა იყოს მზად სესიაზე მინიჭებამდე",
      generic: "შეკვეთის სესიაზე მინიჭება ვერ მოხერხდა",
      networkError: "ქსელის შეცდომა — შეამოწმეთ კავშირი და სცადეთ თავიდან",
    },
  },
  statusControl: {
    assignFirst: "ჯერ სესიაზე მიამაგრეთ",
    assignFirstDescription: "ეს შეკვეთა უნდა იყოს მიტანის სესიაში მიტანილად მარკირებამდე",
    overrideTitle: "სტატუსის შეცვლის დადასტურება",
    overrideMessage: "ამ შეკვეთას უკვე აქვს მიტანის სტატუსი. ცვლილება ჩაანაცვლებს არსებულ მდგომარეობას.",
    overrideConfirm: "დადასტურება",
    overrideStatus: "სტატუსის გადაფარვა",
    transitionBlocked: "ეს სტატუსის ცვლილება დაუშვებელია",
    cancelPaidTitle: "გაუქმდეს გადახდილი შეკვეთა?",
    cancelPaidMessage:
      "ამ შეკვეთის ღირებულებაა {{amount}}₾. დარწმუნებული ხართ, რომ გსურთ მისი გაუქმება? ეს მოქმედება უნდა შესრულდეს მხოლოდ თუ თანხა დაბრუნდა.",
    cancelPaidConfirm: "დიახ, გააუქმე შეკვეთა",
  },
  auth: {
    signIn: "შესვლა",
    signOut: "გამოსვლა",
    signOutSuccess: "წარმატებით გამოხვედით სისტემიდან",
    logoutConfirm: {
      title: "გამოსვლა",
      description:
        "დარწმუნებული ხართ, რომ გსურთ სისტემიდან გამოსვლა? თქვენ მოგიწევთ ხელახლა შესვლა შეკვეთებზე წვდომისთვის.",
      confirm: "გამოსვლა",
    },
    email: "ელ. ფოსტა",
    password: "პაროლი",
    welcomeBack: "კეთილი იყოს თქვენი დაბრუნება!",
    signInPrompt: "შედით შეკვეთების მართვის სისტემაში",
    signingIn: "შესვლა...",
    success: "კეთილი იყოს თქვენი დაბრუნება!",
    error: "არასწორი მონაცემები",
    authenticationError: "ავთენტიფიკაციის შეცდომა",
    forgotPassword: "დაგავიწყდათ პაროლი?",
    resetPassword: "პაროლის აღდგენა",
    resetPasswordPrompt: "შეიყვანეთ ელ-ფოსტა პაროლის აღდგენის ბმულის მისაღებად",
    sendResetLink: "ბმულის გაგზავნა",
    sendingResetLink: "იგზავნება აღდგენის ბმული...",
    passwordResetEmailSent: "პაროლის აღდგენის ბმული გაიგზავნა! შეამოწმეთ თქვენი საფოსტო ყუთი.",
    passwordResetFailed: "პაროლის აღდგენა ვერ მოხერხდა",
    resetLinkSent: "პაროლის აღდგენის ბმული გაგზავნილია! შეამოწმეთ თქვენი ელ-ფოსტა.",
    backToSignIn: "შესვლაზე დაბრუნება",
    tokenExpired: "პაროლის აღდგენის ბმულს ვადა გაუვიდა",
    tokenExpiredDescription:
      "ეს ბმული ვადაგასულია ან უკვე გამოყენებულია. გთხოვთ გამოიყენოთ 'დაგავიწყდათ პაროლი?' ახალი ბმულის მოსათხოვნად, ან დაუკავშირდით ადმინს თქვენი ბმულის ხელახლა მისაღებად.",
    recoveryError: "შეცდომა",
    setNewPassword: "ახალი პაროლის დაყენება",
    setPasswordPrompt: "შეიყვანეთ თქვენი ახალი პაროლი",
    newPassword: "ახალი პაროლი",
    confirmPassword: "პაროლის დადასტურება",
    setPassword: "პაროლის დაყენება",
    settingPassword: "პაროლი ყენდება...",
    passwordsDoNotMatch: "პაროლები არ ემთხვევა",
    passwordTooShort: "პაროლი უნდა იყოს მინიმუმ 8 სიმბოლო და შეიცავდეს დიდ ასოს, პატარა ასოს და ციფრს",
    passwordUpdated: "პაროლი წარმატებით განახლდა! ახლა შეგიძლიათ შეხვიდეთ სისტემაში.",
    cancelPasswordReset: "პაროლის აღდგენის გაუქმება",
    sending: "გაგზავნა...",
    tryForgotPassword: "არასწორი პაროლი? გამოიყენეთ 'დაგავიწყდათ პაროლი' პაროლის დასაყენებლად.",
    magicLinkSent: "შესვლის ბმული გაგზავნილია!",
    checkEmailForLink: "შეამოწმეთ ელფოსტა შესვლის ბმულისთვის.",
    placeholders: {
      email: "მენეჯერი@example.com",
      password: "••••••••",
      newPassword: "შეიყვანეთ ახალი პაროლი",
      confirmPassword: "დაადასტურეთ ახალი პაროლი",
    },
    madeIn: "შექმნილია საქართველოში",
    noAccount: "არ გაქვთ ანგარიში?",
    requestAccess: "წვდომის მოთხოვნა",
    signUp: "რეგისტრაცია",
    haveAccount: "უკვე გაქვთ ანგარიში?",
    modalTitle: "კეთილი იყოს თქვენი მობრძანება OrderFlow-ში",
    modalDescription: "შედით თქვენი შეკვეთების სამართავად",
    welcomeTitle: "კეთილი იყოს თქვენი მობრძანება OrderFlow-ში",
    welcomeSubtitle: "შედით ან შექმენით ანგარიში გასაგრძელებლად.",
    continueWithGoogle: "Google-ით გაგრძელება",
    or: "ან",
    continue: "გაგრძელება",
    invalidEmail: "გთხოვთ შეიყვანოთ ვალიდური ელ-ფოსტა",
    createAccount: "ანგარიშის შექმნა",
    welcomeAboard: "კეთილი იყოს თქვენი მობრძანება OrderFlow-ში",
    accountExists: "ანგარიში უკვე არსებობს — სცადეთ შესვლა",
    signInFailed: "არასწორი ელ-ფოსტა ან პაროლი — ან სცადეთ ანგარიშის შექმნა",
    checkInbox: "შეამოწმეთ ელ-ფოსტა",
    signupSuccess: "ანგარიში შეიქმნა — დაადასტურეთ ელ-ფოსტა შესასვლელად.",
    resetEmailSent: "შეამოწმეთ ელ-ფოსტა",
    resetEmailSentDesc: "თუ ანგარიში არსებობს, აღდგენის ბმული გამოგზავნილია.",
  },
  orders: {
    title: "შეკვეთების მართვის სისტემა",
    subtitle: "მართეთ შეკვეთები Facebook Messenger, Viber, WhatsApp და Telegram-დან",
    ordersLabel: "შეკვეთები",
    groups: {
      today: "დღეს",
      yesterday: "გუშინ",
      thisWeek: "ამ კვირაში",
      older: "ძველი",
      ordersCount: "{{count}} შეკვეთა",
      ordersCountSingular: "{{count}} შეკვეთა",
      noOrders: "ამ პერიოდში შეკვეთები არ არის",
    },
    kpi: {
      today: "დღეს",
      toProcess: "დასამუშავებელი",
      revenue: "შემოსავალი",
      newCustomers: "ახალი",
      returningCustomers: "დაბრუნებული",
      sectionTitle: "დღის მიმოხილვა",
      deliveredToday: "დღეს მიტანილი",
      issues: "პრობლემები",
      yesterday: "გუშინ",
      ordersLabel: "შეკვეთა",
    },
    welcome: {
      morning: "დილა მშვიდობისა",
      afternoon: "დღე მშვიდობისა",
      evening: "საღამო მშვიდობისა",
    },
    encouragement: {
      fresh: "მზად ხართ შეკვეთებისთვის?",
      good: "ყოჩაღ, კარგად მიდიხარ",
      great: "ძაან მაგარი პროგრესი გაქვს!",
      incredible: "რა მაგარი დღეაა! უბრალოდ საუკეთესო ხარ",
    },
    singleOrder: "ერთი შეკვეთა",
    bulkUpload: "მასობრივი ატვირთვა",
    browseAll: "შეკვეთების ისტორიის ნახვა",
    ordersFound: "ნაპოვნია {{count}} შეკვეთა",
    ordersFoundPlural: "ნაპოვნია {{count}} შეკვეთა",
    showing: "ნაჩვენებია",
    perPage: "გვერდზე",
    exportWord: "სტიკერების ექსპორტი",
    exportingWord: "სტიკერების ექსპორტი...",
    exportExcel: "მონაცემების ექსპორტი",
    showGuide: "გზამკვლევის ჩვენება",
    exporting: "ექსპორტირება...",
    exportSelected: "არჩეულის მონაცემების ექსპორტი",
    exportSelectedWord: "არჩეული შეკვეთების ექსპორტი",
    exportAllExcel: "ყველას ექსპორტი Excel-ში",
    exportAllWord: "ყველას ექსპორტი Word-ში",
    sectionActions: "სექციის მოქმედებები",
    columnsLabel: "სვეტები",
    wordExportConfig: {
      title: "სტიკერების ექსპორტი - კურიერის კონფიგურაცია",
      description: "მოარგეთ სტიკერები კურიერს",
      scope: {
        title: "ექსპორტის კონფიგურაცია",
        selected: "მხოლოდ მონიშნული შეკვეთები",
        selectedCount: "{{count}} მონიშნულია",
        page: "მხოლოდ ხილული გვერდი",
        pageCount: "{{count}} შეკვეთა",
        all: "ყველა გაფილტრული შეკვეთა",
        allCount: "{{count}} შეკვეთა",
      },
      fields: {
        title: "საბეჭდი ველები",
        selectAll: "ყველას არჩევა",
        deselectAll: "არჩევის გაუქმება",
        orderNumber: "შეკვეთის ნომერი",
        customerName: "კლიენტის სახელი",
        phone: "ტელეფონის ნომერი",
        address: "მიწოდების მისამართი",
        products: "პროდუქტები",
        price: "სრული ფასი",
        date: "შეკვეთის თარიღი",
        comments: "კომენტარები",
        csrName: "ოპერატორის სახელი",
      },
      stickerOptions: {
        title: "სტიკერის ოპციები",
        includeEmojis: "ემოჯის ჩართვა (🌍, 📱, 💸, 👤)",
        includeHeader: "თავსართის ჩართვა თითოეულ სტიკერზე",
        includeFooter: "ქვედა ბარათის ჩართვა თითოეულ სტიკერზე",
      },
      buttons: {
        cancel: "გაუქმება",
        export: "სტიკერების ექსპორტი",
      },
    },
    statusUpdated: "სტატუსი განახლდა",
    statusUpdatedToNew: "შეკვეთა მზადაა დასამუშავებლად",
    paymentConfirmed: "გადახდა დადასტურდა",
    markAsPaid: "გადახდილია",
    autoGenerateHint: "დატოვეთ ცარიელი ავტომატური გენერაციისთვის:",
    addOrder: "დამატება",
    viewOrder: "დეტალების ნახვა",
    deleteOrder: "შეკვეთის წაშლა",
    confirmOrderNumberChange: "შეკვეთის ნომრის ცვლილების დადასტურება",
    confirmOrderNumberChangeDesc:
      "შეკვეთის ნომრის შეცვლამ შეიძლება გავლენა მოახდინოს თვალყურის დევნებასა და ინვოისებზე. დარწმუნებული ხართ, რომ გსურთ მისი შეცვლა?",
    noOrders: "შეკვეთები არ მოიძებნა",
    noOrdersDesc: "სცადეთ ფილტრების შეცვლა ან დაამატეთ ახალი შეკვეთა.",
    noActiveOrders: "აქტიური შეკვეთები არ არის",
    noActiveOrdersDesc: "შექმენით ახალი შეკვეთა ან აღადგინეთ არქივიდან",
    noResults: "თქვენს ფილტრებს არ შეესაბამება არცერთი შეკვეთა",
    noResultsDesc:
      "სცადეთ ძებნის პარამეტრების ან ფილტრების შეცვლა, ან გაასუფთავეთ ყველა ფილტრი ყველა შეკვეთის სანახავად.",
    selected: "არჩეულია",
    bulkEdit: "მასობრივი რედაქტირება",
    bulkEditTitle: "შეკვეთების მასობრივი რედაქტირება",
    bulkEditDesc:
      "განაახლეთ {{count}} არჩეული შეკვეთა. დატოვეთ ველები ცარიელი არსებული მნიშვნელობების შესანარჩუნებლად.",
    archive: "არქივი",
    archiving: "არქივირება...",
    archiveOrders: "დაარქივება",
    archiveConfirm: "დავაარქივოთ {{count}} შეკვეთა?",
    archiveConfirmDesc: "ეს შეკვეთები დაარქივდება. მათი აღდგენა შესაძლებელია არქივის გვერდიდან.",
    restore: "აღდგენა",
    processing: "მუშავდება",
    deletePermanently: "სამუდამოდ წაშლა",
    deleteConfirm: "სამუდამოდ წავშალოთ {{count}} შეკვეთა?",
    deleteConfirmTitle: "შეკვეთების სამუდამო წაშლა?",
    deleteConfirmDesc: "ეს მოქმედება შეუქცევადია. შეკვეთები და ყველა დაკავშირებული მონაცემი სამუდამოდ წაიშლება.",
    deleteConfirmText: "აკრიფეთ DELETE დასადასტურებლად:",
    deleteTypePlaceholder: "აკრიფეთ DELETE აქ",
    deleteSingleTitle: "წავშალოთ შეკვეთა?",
    deleteSingleDesc: "ეს მოქმედება შეუქცევადია. შეკვეთა სამუდამოდ წაიშლება.",
    deleteSuccess: "შეკვეთა წარმატებით წაიშალა",
    keepExisting: "არსებულის შენარჩუნება",
    mixedStatuses: "შერეული სტატუსები — საერთო გადასვლა არ არსებობს",
    noChanges: "ცვლილებები არ არის",
    selectAtLeastOne: "გთხოვთ აირჩიოთ მინიმუმ ერთი ველი განახლებისთვის",
    updating: "მიმდინარეობს განახლება..",
    updateOrders: "შეკვეთების განახლება",
    backToOrders: "შეკვეთებზე დაბრუნება",
    archivedOrders: "დაარქივებული შეკვეთები",
    table: {
      order: "შეკვეთა",
      orderNumber: "შეკვეთა #",
      customer: "კლიენტი",
      phone: "ტელეფონი",
      products: "პროდუქტები",
      address: "მისამართი",
      price: "ფასი",
      category: "კატეგორია",
      status: "სტატუსი",
      source: "წყარო",
      date: "თარიღი",
      comments: "შენიშვნები",
      actions: "მოქმედებები",
      density: "სიმჭიდროვე",
      columns: "სვეტები",
      session: "სესია",
    },
    tableControls: {
      densitySettings: "ცხრილის სიმჭიდროვის პარამეტრები",
      columnSettings: "სვეტების ხილვადობის პარამეტრები",
      comfortable: "კომფორტული",
      compact: "კომპაქტური",
      cozy: "მოსახერხებელი",
      showAll: "ყველას ჩვენება",
      viewDetails: "დეტალების ნახვა",
      actionsFor: "მოქმედებები შეკვეთისთვის",
    },
    filters: {
      searchPlaceholder: "ძებნა კლიენტის სახელით, ტელეფონით ან შეკვეთის ნომრით...",
      searchShort: "შეკვეთის ძებნა...",
      searchOrder: "ძებნა",
      searchHelp: "ძებნადი: შეკვეთის ID, კლიენტის სახელი, ტელეფონი, პროდუქტები, შენიშვნები",
      status: "სტატუსი",
      source: "წყარო",
      category: "კატეგორია",
      clearAll: "ყველა ფილტრის გასუფთავება",
      openFilters: "ფილტრების გახსნა",
      title: "ფილტრები",
      sourceHelp: "საიდან მოვიდა შეკვეთა (Viber, WhatsApp და ა.შ.)",
      categoryHelp: "პროდუქტის კატეგორია (მაგ., ავეჯი, ელექტრონიკა)",
    },
    sort: {
      sortBy: "დალაგება",
      dateNewest: "თარიღი (ახალი პირველი)",
      dateOldest: "თარიღი (ძველი პირველი)",
      customerAZ: "კლიენტის სახელი (ა-ჰ)",
      customerZA: "კლიენტის სახელი (ჰ-ა)",
      priceHighLow: "ფასი (მაღლიდან დაბალამდე)",
      priceLowHigh: "ფასი (დაბლიდან მაღლამდე)",
    },
    statuses: {
      new: "ახალი",
      processing: "მუშავდება",
      completed: "მზადაა",
      cancelled: "გაუქმებული",
      "out for delivery": "მიტანის პროცესში",
      delivered: "მიტანილია",
      "delivery failed": "მიტანა ვერ მოხერხდა",
      "awaiting payment": "გადახდის მოლოდინში",
    },
    sources: {
      viber: "Viber",
      whatsapp: "WhatsApp",
      telegram: "Telegram",
      manual: "ხელით",
      facebookMessenger: "Facebook Messenger",
      instagram: "Instagram",
    },
    detail: {
      title: "შეკვეთის დეტალები",
      orderNumber: "შეკვეთის ნომერი",
      status: "სტატუსი",
      category: "კატეგორია",
      assignedTo: "პასუხისმგებელი პირი",
      customerInfo: "მომხმარებლის ინფორმაცია",
      socialName: "სახელი სოც. მედიაში",
      realName: "რეალური სახელი",
      phone: "ტელეფონი",
      address: "მისამართი",
      orderDetails: "შეკვეთის დეტალები",
      parsedItems: "ამოღებული ელემენტები",
      rawInput: "დაუმუშავებელი ტექსტი",
      price: "ფასი",
      orderComments: "დამატებითი ინფორმაცია",
      comments: "კომენტარები",
      source: "წყარო",
      createdAt: "შექმნის თარიღი",
      viewFormatted: "ფორმატირებული ნახვა",
      viewRaw: "JSON ფორმატში ნახვა",
      confirmDelete: "დარწმუნებული ხართ?",
      deleteWarning: "ეს მოქმედება შეუქცევადია. შეკვეთა სამუდამოდ წაიშლება.",
      deleting: "იშლება...",
      saving: "ინახება...",
      saveChanges: "ცვლილებების შენახვა",
      unsavedChanges: "შეუნახავი ცვლილებები",
      unsavedChangesWarning:
        "თქვენ გაქვთ შეუნახავი ცვლილებები რომლებიც დაიკარგება. დარწმუნებული ხართ, რომ გსურთ დახურვა შენახვის გარეშე?",
      continueEditing: "რედაქტირების გაგრძელება",
      discardChanges: "ცვლილებების გაუქმება",
      sectionMetadata: "შეკვეთის მეტამონაცემები",
      sectionCustomer: "კლიენტის ინფორმაცია",
      sectionOrderDetails: "შეკვეთის დეტალები",
      sectionStatus: "სტატუსი და მართვა",
      deliveryHistory: "მიწოდების ისტორია",
      useEditor: "რედაქტორის გამოყენება",
      rawJSON: "JSON ფორმატი",
      change: "ცვლილება",
      changes: "ცვლილება",
      trackingLink: "თვალყურის ლინკი",
      copyTrackingLink: "ლინკის კოპირება",
      trackingLinkCopied: "ლინკი დაკოპირდა",
    },
    add: {
      title: "ახალი შეკვეთის დამატება",
      smartInput: "ჭკვიანი შეყვანა",
      smartInputDesc: "ჩასვით შეტყობინება ემოჯი სტრუქტურით ავტომატური დამუშავებისთვის",
      manualEntry: "ხელით შევსება",
      manualEntryDesc: "შეავსეთ ფორმა ხელით",
      toggleHelp: "დახმარების ჩართვა/გამორთვა",
    },
    messages: {
      exportSuccess: "შეკვეთები Excel-ში წარმატებით ჩაიტვირთა",
      exportWordSuccess: "Word დოკუმენტი წარმატებით ექსპორტირდა",
      exportSelectedSuccess: "არჩეული შეკვეთები Excel-ში წარმატებით ჩაიტვირთა",
      exportSelectedWordSuccess: "არჩეული შეკვეთები Word-ში წარმატებით ჩაიტვირთა",
      noOrdersToExport: "ექსპორტისთვის ხელმისაწვდომი შეკვეთები არ არის. ჯერ დაამატეთ შეკვეთები.",
      exportWordError: "Word დოკუმენტი ვერ ექსპორტირდა. სცადეთ ხელახლა.",
      updateSuccess: "შეკვეთა წარმატებით შენახულია",
      updateError: "შეკვეთის განახლება ვერ მოხდა",
      deleteSuccess: "შეკვეთა წაშლილია",
      deleteError: "შეკვეთა ვერ წაიშალა",
      validationError: "რაღაც შესასწორებელია",
      createSuccess: "შეკვეთა წარმატებით შეიქმნა",
      createError: "შეკვეთა ვერ შეიქმნა. სცადეთ ხელახლა.",
      fetchError: "შეკვეთები ვერ ჩაიტვირთა",
      bulkEditSuccess: "შეკვეთები წარმატებით განახლდა",
      bulkEditError: "შეკვეთები ვერ განახლდა",
      archiveSuccess: "{{count}} შეკვეთა დაარქივდა",
      archiveError: "დაარქივება ვერ დასრულდა",
      archiveUndo: "არქივაცია გაუქმდა - შეკვეთები აღდგა",
      restoreSuccess: "{{count}} შეკვეთა აღდგენილია",
      restoreError: "აღდგენა ვერ დასრულდა",
      restoreUndo: "აღდგენა გაუქმდა - შეკვეთები დაარქივდა",
      deletePermSuccess: "შეკვეთები სამუდამოდ წაიშალა",
      deletePermError: "სამუდამო წაშლა ვერ მოხდა",
      duplicateCheckError: "შეკვეთის ნომრის დუბლიკატი ვერ შემოწმდა",
      databaseUpdateError: "შეკვეთა ბაზაში ვერ შეინახა",
      databaseDeleteError: "შეკვეთა ბაზიდან ვერ წაიშალა",
      newOrderReceived: "ახალი შეკვეთა მიიღეთ!",
    },
    notAnOrder: {
      title: "ეს არ ჰგავს ახალ შეკვეთას",
      description: "ტექსტი სხვა ტიპის საუბარს წარმოადგენს",
      detected: "აღმოჩენილია",
      extractedInfo: "ამოღებული ინფორმაცია",
      orderRef: "შეკვეთის ნომერი",
      suggestion: "რჩევა",
      copyPhone: "ტელეფონის კოპირება",
      phoneCopied: "ტელეფონი დაკოპირდა",
      phoneCopiedDesc: "შეგიძლიათ გამოიყენოთ ეს ნომერი არსებული შეკვეთის მოსაძებნად",
      tryDifferent: "სხვა ტექსტით ცდა",
      messages: {
        order_modification: "ეს არსებული შეკვეთის შეცვლის მოთხოვნას ჰგავს.",
        order_inquiry: "ეს შეკვეთის სტატუსის შესახებ კითხვას ჰგავს.",
        complaint: "ეს არსებული შეკვეთის შესახებ პრეტენზიას ჰგავს.",
        general_inquiry: "ეს ზოგადი კითხვაა, არა ახალი შეკვეთა.",
        unclear: "ვერ დადგინდა ეს ახალი შეკვეთაა თუ სხვა რამ.",
        default: "ეს არ ჰგავს ახალ შეკვეთას.",
      },
      suggestions: {
        order_modification: "მოძებნეთ კლიენტის არსებული შეკვეთა ცვლილებების შესატანად.",
        order_inquiry: "მოძებნეთ კლიენტის შეკვეთა სტატუსის შესამოწმებლად.",
        complaint: "მოძებნეთ კლიენტის შეკვეთა პრობლემის მოსაგვარებლად.",
        general_inquiry: "ეს ზოგადი კითხვაა - შეკვეთა არ იქმნება.",
        unclear: "გადახედეთ შეტყობინებას ან მოითხოვეთ დაზუსტება.",
        default: "გადახედეთ შეტყობინებას შესაბამისი ქმედების დასადგენად.",
        phoneHint: "გამოიყენეთ ტელეფონი {{phone}} მოსაძებნად.",
      },
    },
    incomplete: {
      title: "არასრული შეკვეთის მონაცემები",
      description: "ზოგიერთი სავალდებულო ველი აკლია ამოღებულ შეკვეთას",
    },
    conversationType: {
      newOrder: "ახალი შეკვეთა",
      modification: "შეკვეთის შეცვლა",
      inquiry: "შეკვეთის შესახებ კითხვა",
      complaint: "პრეტენზია",
      general: "ზოგადი კითხვა",
      unclear: "გაურკვეველი",
    },
    placeholders: {
      orderNumber: "მაგ., 133",
      customerName: "გიორგი მელაძე",
      customerPhone: "+995555123456",
      csrName: "მაგ., თიკო",
      address: "ვაჟა-ფშაველას 10, თბილისი",
      orderMessage: "საწმენდი სპრეი 2 ცალი, ხელსახოცი 3 ცალი...",
      selectCategory: "აირჩიეთ კატეგორია (სავალდებულო)",
      selectCategoryOptional: "აირჩიეთ კატეგორია",
      totalPrice: "0.00 ₾",
      comments: "ნებისმიერი შენიშვნა ან ინსტრუქცია...",
      noAddress: "მისამართი არ არის მითითებული",
      managerName: "მენეჯერის სახელი",
      socialHandle: "სოციალური მედიის სახელი",
      fullName: "სრული სახელი გვარით",
      deliveryNotes: "მიწოდების შენიშვნები, დრო, ინსტრუქციები...",
      pasteMessage: "ჩასვით Messanger, Viber/WhatsApp შეტყობინება აქ...",
      pasteMinimal: "ჩასვით შეტყობინება აქ…",
      pasteExample: "მაგალითი:\nანა გელაშვილი\n599123456\nვაჟა-ფშაველას 10\nსაწმენდი სპრეი - 2 ცალი - 15 ლარი",
      parsedItems: "მაგ., საწმენდი სპრეი x2, ხელსახოცი x3, ჭურჭლის სარეცხი საშუალება x1",
      selectDeliveryDate: "აირჩიეთ მიწოდების თარიღი",
    },
    labels: {
      orderId: "შეკვეთის ID",
      lastUpdated: "ბოლო განახლება",
      postedBy: "დამატებულია",
      extractedData: "ამოღებული მონაცემები",
      startOver: "თავიდან დაწყება",
      socialName: "სახელი სოც. მედიაში",
      realName: "რეალური სახელი *",
      phoneIcon: "ტელეფონი",
      deliveryAddress: "მიწოდების მისამართი",
      deliveryAddressSimple: "მიწოდების მისამართი",
      products: "პროდუქტები",
      totalPriceIcon: "სრული ფასი (₾)",
      commentsIcon: "კომენტარები და დრო",
      pasteOrderMessage: "ჩასვით შეკვეთის შეტყობინება",
      orderNumber: "შეკვეთის ნომერი",
      customerName: "კლიენტის სახელი *",
      customerPhone: "კლიენტის ტელეფონი",
      csrName: "დამატებულია",
      source: "წყარო",
      category: "კატეგორია *",
      totalPrice: "სრული ფასი",
      commentsSpecial: "კომენტარები / სპეციალური ინსტრუქციები",
      orderMessage: "შეკვეთის შეტყობინება",
      orderMetadata: "შეკვეთის მეტამონაცემები",
      customerInformation: "კლიენტის ინფორმაცია",
      pricingDetails: "ფასები და დეტალები",
      context: "კონტექსტი",
      contextPlaceholder: "აირჩიეთ კონტექსტი (არასავალდებულო)",
      contextHint: "შიდა დაჯგუფებისთვის. არ ახდენს გავლენას მიტანაზე.",
      requestedDeliveryDate: "მოთხოვნილი მიწოდების თარიღი",
      noDeliveryDate: "თარიღის გარეშე (დაუყოვნებლივ)",
      moreDetails: "+ მეტი დეტალი",
      deliveryTime: "მიტანის დრო",
      // Fulfillment type labels
      fulfillmentPickup: "გატანა",
      fulfillmentDelivery: "მიწოდება",
      fulfillmentUndetermined: "არ არის მითითებული",
      // Missing info reason labels
      reasonMessengerChat: "მესენჯერში საუბარი",
      reasonWillProvideLater: "მოგვიანებით მოგვაწვდის",
      reasonKnownCustomer: "ნაცნობი კლიენტი",
      reasonPickupOrder: "თვითგატანა",
      reasonNotMentioned: "არ მოუწოდებია",
      reasonNotNeeded: "არ არის საჭირო",
      // Payment & warning hints
      partialPaymentHint: "გადახდის გაყოფა — იხ. კომენტარები",
      noProductsHint: "პროდუქტები ვერ ამოიცნო — სერვისული შეკვეთა",
    },
    buttons: {
      processingAI: "მუშავდება AI-ით...",
      processAI: "დამუშავება AI-ით",
      saveOrder: "შეკვეთის შენახვა",
      createOrder: "შეკვეთის შექმნა",
      saving: "ინახება...",
      addOrder: "დამატება",
    },
    descriptions: {
      viewEditOrder: "იხილეთ და შეცვალეთ შეკვეთის დეტალები, სტატუსი და კლიენტის ინფორმაცია.",
    },
    errors: {
      categoryRequired: "კატეგორია სავალდებულოა",
      customerNameRequired: "კლიენტის სახელი სავალდებულოა",
      pasteTextRequired: "გთხოვთ ჩასვით ტექსტი დასამუშავებლად",
      extractionFailed: "შეკვეთის მონაცემების ამოღება ვერ მოხერხდა. გთხოვთ გამოიყენოთ ხელით შეყვანა.",
      failedToExtract: "შეკვეთის მონაცემების ამოღება ვერ მოხერხდა",
    },
    success: {
      orderCreated: "შესანიშნავი! ახალი შეკვეთა დაემატა",
      orderExtracted: "შეკვეთის მონაცემები წარმატებით იქნა ამოღებული. შეამოწმეთ და საჭიროების შემთხვევაში ჩაასწორეთ.",
      extractionSuccess: "წარმატება!",
    },
    duplicate: {
      title: "დუბლირებული შეკვეთის ნომერი",
      description: "შეკვეთა #{{orderNumber}} უკვე არსებობს. გთხოვთ გამოიყენოთ სხვა შეკვეთის ნომერი.",
    },
    unsavedChanges: {
      title: "შეუნახავი ცვლილებები",
      description: "თქვენ გაქვთ {{count}} შეუნახავი ცვლილება. დარწმუნებული ხართ, რომ გსურთ მათი გაუქმება?",
      continueEditing: "რედაქტირების გაგრძელება",
      discardChanges: "ცვლილებების გაუქმება",
    },
    smart: {
      helperText: "ჩასვით WhatsApp/Viber/Messenger-დან. საკმარისია ერთი შეკვეთა.",
    },
    example: {
      hint: "ჩასვით შეტყობინებები WhatsApp, Viber ან ნებისმიერი მესენჯერიდან. მიუთითეთ მომხმარებლის სახელი, ტელეფონი, მისამართი და პროდუქტები.",
    },
  },
  dashboard: {
    title: "ანალიტიკა",
    viewOrders: "შეკვეთების ნახვა",
    dateRange: "თარიღი",
    quickPresets: "სწრაფი არჩევანი",
    from: "დან",
    to: "მდე",
    today: "დღეს",
    yesterday: "გუშინ",
    last7Days: "ბოლო 7 დღე",
    last30Days: "ბოლო 30 დღე",
    last90Days: "ბოლო 90 დღე",
    monthToDate: "თვის დასაწყისიდან",
    yearToDate: "წლის დასაწყისიდან",
    clearFilter: "გასუფთავება",
    filter: {
      allOrders: "ყველა შეკვეთა",
      deliveredOnly: "მხოლოდ მიტანილი",
    },
    metrics: {
      totalOrders: "სულ შეკვეთები",
      totalRevenue: "სრული შემოსავალი",
      avgOrderValue: "საშ. შეკვეთის ღირებულება",
      completionRate: "დასრულების მაჩვენებელი",
      unitsSold: "გაყიდული ერთეული",
      deliverySuccessRate: "მიტანის წარმატება",
      trendSuffix: "წინა პერიოდთან შედარებით",
    },
    charts: {
      ordersOverTime: "შეკვეთები დროში",
      revenueOverTime: "შემოსავალი დროში",
      ordersByStatus: "შეკვეთები სტატუსის მიხედვით",
      ordersBySource: "შეკვეთები წყაროს მიხედვით",
      revenueBySource: "შემოსავალი წყაროს მიხედვით",
      ordersByCategory: "შეკვეთები კატეგორიის მიხედვით",
      topCustomers: "საუკეთესო კლიენტები",
      recentOrders: "ბოლო შეკვეთები",
      dailyOrderTrend: "დღიური შეკვეთების ტენდენცია",
      dailyRevenue: "დღიური შემოსავალი ₾-ში",
      statusDistribution: "სტატუსების განაწილება",
      sourceDistribution: "განაწილება წყაროს მიხედვით",
      revenueDistribution: "შემოსავლის განაწილება წყაროს მიხედვით",
      topCategoriesDescription: "ტოპ 5 კატეგორია",
      customersSpending: "კლიენტები ხარჯების მიხედვით",
      latestOrders: "უახლესი შეკვეთები თქვენი სისტემიდან",
      ordersLabel: "შეკვეთები",
      unitsLabel: "ერთეული",
      dailyOrderAndUnitTrend: "ყოველდღიური შეკვეთები და ერთეულები",
      monthlyOrderAndUnitTrend: "ყოველთვიური შეკვეთები და ერთეულები",
      monthlyOrderTrend: "ყოველთვიური შეკვეთების ტენდენცია",
      monthlyRevenue: "ყოველთვიური შემოსავალი ₾-ში",
      hourlyRevenue: "საათობრივი შემოსავალი ₾-ში",
      todayRevenue: "დღევანდელი შემოსავალი",
      allOrdersFrom: "ყველა შეკვეთა",
      allRevenueFrom: "მთლიანი შემოსავალი",
      mostlyOrdersFrom: "ძირითადად",
      mostlyRevenueFrom: "ძირითადად",
      granularityDaily: "დღიური",
      granularityMonthly: "თვიური",
      revenueLabel: "შემოსავალი (₾)",
    },
    emptyStates: {
      noData: "მონაცემები არ არის ხელმისაწვდომი",
      noOrders: "არჩეულ პერიოდში შეკვეთები არ არის",
      noRevenue: "შემოსავლის მონაცემები არ არის",
      noStatus: "სტატუსის მონაცემები არ არის",
      noSource: "წყაროს მონაცემები არ არის",
      noCategory: "კატეგორიის მონაცემები არ არის",
      noCustomers: "კლიენტების მონაცემები არ არის",
      noRecentOrders: "ბოლო შეკვეთები არ არის",
      customersWillAppear: "კლიენტების სტატისტიკა აქ გამოჩნდება",
      ordersWillAppear: "შეკვეთები აქ გამოჩნდება შექმნის შემდეგ",
    },
    chartError: {
      title: "{{chartName}} შეცდომა",
      retry: "ხელახლა ცდა",
      description: "{{chartName}} ვერ გამოჩნდა. ეს შეიძლება გამოწვეული იყოს არასწორი მონაცემებით ან დროებითი პრობლემით.",
    },
    table: {
      customer: "კლიენტი",
      orders: "შეკვეთები",
      revenue: "შემოსავალი",
      avgOrderValue: "საშ. ღირებულება",
      lastOrder: "ბოლო შეკვეთა",
      orderNumber: "შეკვეთა #",
      status: "სტატუსი",
      amount: "თანხა",
      customerName: "კლიენტის სახელი",
      phone: "ტელეფონი",
      totalSpent: "სრული ხარჯი (₾)",
      viewAll: "ყველას ნახვა",
    },
    export: {
      csv: "CSV ექსპორტი",
      rawData: "ექსპორტი",
      labels: {
        date: "თარიღი",
        orders: "შეკვეთები",
        revenue: "შემოსავალი (₾)",
        status: "სტატუსი",
        count: "რაოდენობა",
        percentage: "პროცენტი",
        category: "კატეგორია",
        source: "წყარო",
        orderNumber: "შეკვეთა #",
        customer: "კლიენტი",
        phone: "ტელეფონი",
        address: "მისამართი",
        price: "ფასი (₾)",
        comments: "შენიშვნა",
        deliveredAt: "მიტანის დრო",
        quantity: "რაოდენობა",
        products: "პროდუქტი",
      },
    },
    periodSummary: {
      title: "ანალიტიკა",
      loading: "მონაცემების ანალიზი...",
      error: "შეჯამება ვერ შეიქმნა",
      retry: "შეჯამების განახლება",
      generatedBy: "AI შეჯამება",
    },
  },
  bulk: {
    title: "მრავალი შეკვეთის ატვირთვა",
    uploadTab: "Excel ატვირთვა",
    smartPasteTab: "სმარტ ჩასმა",
    excelUploadDesc: "ატვირთეთ Excel ფაილი Messanger, Viber/WhatsApp ჩატის ექსპორტით",
    smartPasteDesc: "ჩასვით ჩატის შეტყობინებები პირდაპირ დამუშავებისთვის",
    dragDrop: "გადმოიტანეთ Excel ფაილი აქ, ან დააკლიკეთ არჩევისთვის",
    fileTypes: "მხარდაჭერილია .xlsx და .xls ფაილები",
    uploading: "იტვირთება...",
    processing: "მუშავდება AI-ით...",
    analyzing: "ანალიზი",
    parsingOrders: "შეკვეთების დამუშავება...",
    longOperationHint: "დიდი პაკეტების დამუშავებას შეიძლება დასჭირდეს ~1 წუთი. გთხოვთ მოიცადოთ...",
    pasteInstructions: "ჩასვით ექსპორტირებული ჩატის შეტყობინებები ქვემოთ",
    pasteTextarea: "ჩასვით ჩატის ტექსტი აქ...",
    parseOrders: "შეკვეთების დამუშავება",
    importSelected: "არჩეულების დამატება  ({{count}})",
    import: "იმპორტი",
    importing: "დამატება...",
    backToUpload: "ატვირთვაზე დაბრუნება",
    newUpload: "ახალი ატვირთვა",
    summary: {
      title: "შეჯამება",
      success: "{{count}} შეკვეთა წარმატებით დაემატა!",
      successPlural: "{{count}} შეკვეთა წარმატებით დაემატა!",
      failed: "{{count}} შეკვეთა ვერ დაემატა",
      failedPlural: "{{count}} შეკვეთა ვერ დაემატა",
      duplicates: "{{count}} დუბლიკატი აღმოჩენილია",
      duplicatesPlural: "{{count}} დუბლიკატი აღმოჩენილია",
      imported: "წარმატებით დაემატა",
      failedToImport: "დამატება ვერ მოხერხდა",
      duplicatesFound: "დუბლიკატები ნაპოვნია",
      processedIn: "დამუშავდა",
      seconds: "წამში",
      estimatedManualEntry: "სავარაუდო ხელით შეყვანის დრო:",
      minutes: "წუთი",
      timeSaved: "თქვენ დაზოგეთ დაახლოებით",
      estimatedTimeSaved: "დაზოგილი დრო:",
      hours: "საათი",
      timeCalculationNote: "(დაფუძნებულია საშუალოდ 3 წუთზე თითო შეკვეთისთვის)",
      errorDetails: "შეცდომის დეტალები:",
    },
    review: {
      title: "შეამოწმეთ და შეარჩიეთ შეკვეთები",
      select: "არჩევა",
      selectAll: "ყველას არჩევა",
      deselectAll: "ყველას გაუქმება",
      validOrders: "ვალიდური შეკვეთები: {{count}}",
      invalidOrders: "არავალიდური: {{count}}",
      selectedCount: "არჩეული: {{count}}",
      filterAll: "ყველა შეკვეთა",
      filterValid: "მხოლოდ ვალიდური",
      filterErrors: "მხოლოდ შეცდომები",
      filterDuplicates: "მხოლოდ დუბლიკატები",
      filterRejected: "უარყოფილი",
    },
    statuses: {
      rejected: "უარყოფილი",
      duplicate: "დუბლიკატი",
      error: "შეცდომა",
      warning: "გაფრთხილება",
      edited: "რედაქტირებული",
      valid: "ვალიდური",
      editing: "რედაქტირება",
      ready: "მზადაა",
    },
    actions: {
      edit: "რედაქტირება",
      save: "შენახვა",
      cancel: "გაუქმება",
      reject: "უარყოფა",
      compare: "შედარება",
      restore: "აღდგენა",
      compareWithExisting: "არსებულ შეკვეთასთან შედარება",
      remove: "წაშლა",
    },
    duplicate: {
      title: "დუბლიკატი შეკვეთის შედარება",
      newOrder: "ახალი შეკვეთა",
      existing: "არსებული",
      fromUpload: "მიმდინარე ატვირთვიდან",
      fromDatabase: "მონაცემთა ბაზიდან",
      earlierInBatch: "ადრე ამ პაკეტში",
      orderNumber: "შეკვეთა #:",
      customer: "კლიენტი:",
      phone: "ტელეფონი:",
      address: "მისამართი:",
      total: "ჯამი:",
      products: "პროდუქტები:",
      created: "შექმნილია:",
      checkRow: "შეამოწმეთ რიგი:",
      detectionWarning: "დუბლიკატის აღმოჩენა",
      close: "დახურვა",
    },
    rejected: {
      title: "უარყოფილი შეკვეთები",
      count: "{{count}} შეკვეთა უარყოფილია",
      countPlural: "{{count}} შეკვეთა უარყოფილია",
      restoreAll: "ყველას აღდგენა",
      empty: "უარყოფილი შეკვეთები არ არის",
    },
    tips: {
      title: "რჩევები",
      editReject: "დააწკაპუნეთ რიგზე რედაქტირებისთვის, გამოიყენეთ უარყოფის ღილაკი გამოსარიცხად",
      editInline: "ველების პირდაპირი რედაქტირება. ცვლილებები ავტომატურად ინახება.",
      excelFormat: "დარწმუნდით, რომ Excel შეიცავს ჩატის შეტყობინებებს სტანდარტულ ფორმატში",
      excelStructure: "კარგი იქნება თუ შეკვეთა დაიწყება [ თარიღი/დრო ] სტრუქტურით",
      excelExtract: "AI ავტომატურად ამოიღებს მომხმარებლის დეტალებს, პროდუქტებსა და ფასებს",
      pasteDirect: "დააკოპირეთ და ჩასვით შეტყობინებები Messanger, Viber/WhatsApp-დან",
      pasteFormats: "ჭკვიანი ფუნქცია ავტომატურად ამოიღებს ინფორმაციას და დაალაგებს შესაბამისი ველების მიხედვით",
      pasteMultiple: "შეგიძლიათ ჩასვათ რამდენიმე შეკვეთა ერთდროულად",
    },
    maxSize: "💾 მაქსიმალური ზომა: 10 MB",
    errors: {
      uploadFailed: "ფაილი ვერ აიტვირთა",
      processingFailed: "შეკვეთები ვერ დამუშავდა",
      noFile: "გთხოვთ აირჩიოთ ფაილი",
      noPaste: "გთხოვთ ჩასვით ტექსტი დასამუშავებლად",
      importFailed: "შეკვეთები ვერ ჩაიტვირთა",
      invalidFile: "არასწორი ფაილი",
      invalidFileDesc: "გთხოვთ ატვირთოთ ვალიდური ფაილი (.xlsx, .xls, ან .csv)",
      noOrders: "შეკვეთები ვერ მოიძებნა",
      extractionFailed: "ფაილიდან შეკვეთების ამოღება ვერ მოხერხდა",
      timeout: "დამუშავების ტაიმაუტი",
      timeoutDesc: "მოთხოვნას ძალიან დიდი დრო დასჭირდა. სცადეთ უფრო პატარა ფაილით.",
      rateLimit: "ლიმიტი ამოწურულია",
      rateLimitDesc: "ძალიან ბევრი მოთხოვნა. გთხოვთ დაიცადოთ და სცადოთ თავიდან.",
      creditsRequired: "კრედიტები საჭიროა",
      creditsRequiredDesc: "AI კრედიტები საჭიროა. გთხოვთ დაამატოთ კრედიტები გასაგრძელებლად.",
      timeoutWithCount: "დამუშავების დრო ამოიწურა. თქვენ გაქვთ ~{{count}} შეკვეთა. სცადეთ {{max}} ან ნაკლები შეკვეთით.",
      duplicateInternal: "დუბლიკატი შეკვეთა #{{orderNumber}} ამ პარტიაში (პირველად რიგში {{row}})",
      duplicateDatabase: "შეკვეთა #{{orderNumber}} უკვე არსებობს თქვენს ბაზაში",
    },
    processingBatches: "ნაწილების დამუშავება...",
    largeFileWarning: "დიდი ფაილი აღმოჩენილია. დამუშავებას შეიძლება დასჭირდეს 60 წამამდე.",
    reviewOrders: "შეკვეთების გადახედვა",
    chooseFile: "ფაილის არჩევა",
    constraintsExcel: ".xlsx, .xls, .csv • მაქს. 10MB",
    dropFile: "ჩააგდეთ ფაილი აქ ან აირჩიეთ",
    dropHere: "ჩააგდეთ ფაილი აქ",
    constraintsPaste: "ჩასვით Viber/WhatsApp-დან • რამდენიმე შეკვეთა შესაძლებელია",
    characters: "სიმბოლო",
    mayTakeLong: "შეიძლება 1+ წუთი დასჭირდეს",
    reviewBeforeImport: "შეკვეთების გადახედვა შესაძლებელია იმპორტამდე",
  },
  categories: {
    cleaningSupplies: "საწმენდი საშუალებები",
    kitchenItems: "სამზარეულოს ნივთები",
    bathroomProducts: "სააბაზანოს პროდუქტები",
    homeDecor: "სახლის დეკორი",
    storageOrganization: "შენახვა და ორგანიზაცია",
    textiles: "ტექსტილი",
    smallAppliances: "პატარა ტექნიკა",
    toolsHardware: "ხელსაწყოები",
    other: "სხვა",
    // Extended categories
    householdGoods: "საყოფაცხოვრებო საქონელი",
    clothingFashion: "ტანსაცმელი და მოდა",
    electronics: "ელექტრონიკა",
    foodRestaurant: "საკვები და რესტორანი",
    pharmacyMedical: "აფთიაქი და მედიცინა",
    retailGeneral: "საცალო ვაჭრობა",
    // Database categories
    b2b: "B2B",
    clothing: "ტანსაცმელი",
    electronicsAppliances: "ელექტრონიკა და ტექნიკა",
    food: "საკვები",
    sportingGoods: "სპორტული საქონელი",
  },
  products: {
    title: "პროდუქტები",
    addProduct: "დამატება",
    editProduct: "პროდუქტის რედაქტირება",
    addProductDesc: "შექმენით ახალი პროდუქტი გარე შეკვეთებისთვის",
    editProductDesc: "განაახლეთ პროდუქტის დეტალები",
    productDetails: "პროდუქტის დეტალები",
    pricing: "ფასები",
    noProducts: "პროდუქტები ჯერ არ არის დამატებული. დააჭირეთ 'პროდუქტის დამატება'-ს დასაწყებად.",
    noProductsFound: "პროდუქტები ვერ მოიძებნა",
    addFirstProduct: "დაამატეთ პირველი პროდუქტი",
    productName: "პროდუქტის დასახელება",
    productNamePlaceholder: "მაგ: ბაგელი",
    productCode: "SKU / პროდუქტის კოდი",
    productCodePlaceholder: "მაგ: PROD-001",
    category: "კატეგორია",
    selectCategory: "აირჩიეთ კატეგორია",
    unit: "ერთეული",
    basePrice: "ფასი",
    variationNote: "ვარიაციების ფასი ემატება ამ საბაზისო ფასს",
    unitPiece: "ცალი",
    unitKg: "კგ",
    unitLiter: "ლიტრი",
    unitMeter: "მ",
    unitSet: "კომპლექტი",
    quantity: "რაოდ.",
    price: "ფასი",
    remove: "წაშლა",
    uncategorized: "კატეგორიის გარეშე",
    categoryLink: "კატეგორიის ლინკი",
    disableCategory: "კატეგორიის გამორთვა",
    disableCategoryDescription:
      "ამ კატეგორიაში არის აქტიური პროდუქტები. გამორთვის შემთხვევაში მომხმარებლები ვეღარ შეძლებენ შეკვეთის გაფორმებას ამ ლინკით.",
    confirmDelete: "ნამდვილად გსურთ პროდუქტის წაშლა?",
    confirmDeleteTitle: "პროდუქტის წაშლა",
    linkCopied: "ლინკი დაკოპირებულია",
    copyFailed: "კოპირება ვერ მოხერხდა",
    toggleIntake: "გარე მიღების გადართვა",
    productImage: "პროდუქტის სურათი",
    uploadImage: "ატვირთეთ სურათი",
    removeImage: "წაშალეთ სურათი",
    imageUploadError: "სურათი ვერ აიტვირთა",
    imageSizeError: "სურათი უნდა იყოს 2MB-ზე ნაკლები",
    imageFormatError: "დასაშვებია მხოლოდ JPEG, PNG და WebP ფორმატები",
    stock: "მარაგი",
    stockHelper: "დატოვეთ ცარიელი თუ მარაგს არ აკონტროლებთ",
    stockPlaceholder: "მაგ: 50",
    minStock: "მინ. მარაგი",
    minStockHelper: "გაფრთხილება გამოჩნდება როცა რაოდენობა ამ დონემდე დაეცემა",
    minStockPlaceholder: "მაგ: 5",
    columns: {
      product: "პროდუქტი",
      price: "ფასი",
      stock: "მარაგი",
      orderLink: "შეკვეთის ლინკი",
    },
    copyLink: "ლინკის კოპირება",
    openLink: "ლინკის გახსნა",
    productsCount: "პროდუქტი",
    activeCount: "აქტიური",
    activeCategoryCount: "აქტიური",
    stockAdjust: {
      title: "მარაგის კორექტირება",
      notePlaceholder: "კორექტირების მიზეზი (სავალდებულო)",
      confirm: "დადასტურება",
      insufficientStock: "არასაკმარისი მარაგი ამ კორექტირებისთვის",
    },
    lowStockBadge: "დაბალი",
    outOfStockBadge: "ამოწურული",
    stockAlertWhisper: "{{low}} დაბალი მარაგი · {{out}} ამოწურული",
    stockFilter: {
      all: "ყველა",
      inStock: "მარაგშია",
      low: "დაბალი",
      outOfStock: "ამოწურული",
    },
    searchPlaceholder: "პროდუქტის ძებნა...",
    toasts: {
      added: "პროდუქტი დამატებულია",
      updated: "პროდუქტი განახლებულია",
      deleted: "პროდუქტი წაშლილია",
      stockUpdated: "მარაგი განახლებულია",
      error: "შეცდომა: {{message}}",
    },
  },
  units: {
    piece: "ცალი",
    kg: "კგ",
    liter: "ლიტრი",
    meter: "მ",
    set: "კომპლექტი",
  },
  notFound: {
    title: "404",
    message: "უკაცრავად! გვერდი ვერ მოიძებნა",
    returnHome: "მთავარზე დაბრუნება",
  },
  register: {
    title: "დაიწყეთ უფასო საცდელი პერიოდი",
    subtitle: "მიიღეთ 14 დღის სრული წვდომა - საკრედიტო ბარათი არ არის საჭირო",
    modal: {
      title: "დავიწყოთ ერთად",
      subtitle: "შემოუერთდით OrderFlow-ს და გარდაქმენით თქვენი შეკვეთების მართვა",
      switchToLogin: "უკვე გაქვთ ანგარიში?",
      signIn: "შესვლა",
    },
    personalInfo: "პირადი ინფორმაცია",
    businessInfo: "ბიზნეს ინფორმაცია",
    fullName: "სრული სახელი",
    email: "ელ-ფოსტის მისამართი",
    phone: "ტელეფონის ნომერი",
    companyName: "კომპანიის სახელი",
    businessType: "ბიზნესის ტიპი",
    referralSource: "როგორ გაიგეთ ჩვენ შესახებ?",
    message: "მოგვიყევით თქვენი ბიზნესის შესახებ",
    fullNamePlaceholder: "გიორგი მელაძე",
    emailPlaceholder: "giorgi@company.com",
    phonePlaceholder: "+995 XXX XXX XXX",
    companyNamePlaceholder: "თქვენი კომპანია",
    selectBusinessType: "აირჩიეთ ბიზნესის ტიპი",
    selectReferralSource: "აირჩიეთ წყარო",
    messagePlaceholder: "შეკვეთების რაოდენობა დღეში, სპეციფიკური საჭიროებები და ა.შ.",
    termsPrefix: "ფორმის გაგზავნით თქვენ ეთანხმებით ჩვენს",
    termsOfService: "მომსახურების პირობებს",
    and: "და",
    privacyPolicy: "კონფიდენციალურობის პოლიტიკას",
    requestAccess: "წვდომის მოთხოვნა",
    submitting: "იგზავნება...",
    haveAccount: "უკვე გაქვთ ანგარიში?",
    signIn: "შესვლა",
    alreadyHaveAccount: "უკვე გაქვთ ანგარიში?",
    trialInfo:
      "დაიწყეთ 14-დღიანი უფასო საცდელი პერიოდი. სრული წვდომა ყველა ფუნქციაზე, საკრედიტო ბარათი არ არის საჭირო.",
    sections: {
      accountInfo: "ანგარიშის მონაცემები",
      personalInfo: "პირადი ინფორმაცია",
      businessInfo: "ბიზნეს ინფორმაცია",
    },
    fields: {
      fullName: "სრული სახელი",
      email: "ელ-ფოსტის მისამართი",
      phone: "ტელეფონის ნომერი",
      password: "პაროლი",
      confirmPassword: "გაიმეორეთ პაროლი",
      companyName: "კომპანიის სახელი",
      businessType: "ბიზნესის ტიპი",
      referralSource: "როგორ გაიგეთ ჩვენ შესახებ?",
      message: "მოგვიყევით თქვენი ბიზნესის შესახებ",
    },
    placeholders: {
      fullName: "გიორგი მელაძე",
      email: "giorgi@company.com",
      phone: "+995 XXX XXX XXX",
      password: "მინ. 8 სიმბოლო",
      confirmPassword: "გაიმეორეთ პაროლი",
      companyName: "თქვენი კომპანია",
      selectType: "აირჩიეთ ბიზნესის ტიპი",
      selectSource: "აირჩიეთ წყარო",
      message: "შეკვეთების რაოდენობა დღეში, სპეციფიკური საჭიროებები და ა.შ.",
    },
    hints: {
      optional: "არასავალდებულო",
      characters: "სიმბოლო",
      passwordMin: "მინიმუმ 8 სიმბოლო",
    },
    terms: {
      bySubmitting: "ანგარიშის შექმნით თქვენ ეთანხმებით ჩვენს",
      termsOfService: "მომსახურების პირობებს",
      and: "და",
      privacyPolicy: "კონფიდენციალურობის პოლიტიკას",
    },
    buttons: {
      submit: "განაცხადის გაგზავნა",
      submitting: "იგზავნება...",
      startTrial: "უფასო საცდელის დაწყება",
      creating: "ანგარიშის შექმნა...",
      next: "გაგრძელება",
      back: "უკან",
    },
    steps: {
      step1: "ანგარიში",
      step2: "პირადი",
      step3: "ბიზნესი",
      step1Title: "შექმენით ანგარიში",
      step2Title: "გვიამბეთ თქვენს შესახებ",
      step3Title: "ბიზნეს დეტალები",
      step1Subtitle: "დაიწყეთ შესვლის მონაცემებით",
      step2Subtitle: "გვსურს გავიცნოთ თქვენ",
      step3Subtitle: "თითქმის მზადაა — ბოლო დეტალები",
      of: "/-დან",
    },
    left: {
      headline: "მართეთ შეკვეთები ახლებურად",
      subheadline: "OrderFlow გეხმარებათ თვალი ადევნოთ ყველა შეკვეთას, კლიენტს და დღეს.",
      feature1: "შეკვეთების რეალურ დროში თვალყურის დევნება",
      feature2: "კლიენტების ჭკვიანი მართვა",
      feature3: "მძლავრი ანალიტიკა და ანგარიშები",
    },
    errors: {
      invalidEmail: "გთხოვთ შეიყვანოთ სწორი ელ-ფოსტის მისამართი",
      requiredField: "ეს ველი სავალდებულოა",
      validationFailed: "შემოწმება ვერ მოხერხდა",
      checkFields: "გთხოვთ შეამოწმოთ სავალდებულო ველები",
      contactSupport: "დახმარებისთვის დაგვიკავშირდით",
      tryAgain: "კიდევ სცადეთ",
      submissionFailed: "რეგისტრაცია ვერ მოხერხდა",
      emailExists: "ეს ელ-ფოსტა უკვე რეგისტრირებულია. გთხოვთ შეხვიდეთ ანგარიშში.",
      passwordMismatch: "პაროლები არ ემთხვევა",
      passwordTooShort: "პაროლი უნდა შეიცავდეს მინიმუმ 8 სიმბოლოს",
    },
    success: {
      title: "წარმატება!",
      description: "თქვენი განაცხადი წარმატებით გაიგზავნა.",
      welcome: "კეთილი იყოს თქვენი მობრძანება OrderFlow-ში!",
      trialStarted: "თქვენი 14-დღიანი უფასო საცდელი პერიოდი დაიწყო. გამოიკვლიეთ ყველა ფუნქცია!",
      loginManually: "ანგარიში შეიქმნა! გთხოვთ შეხვიდეთ გასაგრძელებლად.",
    },
  },
  demo: {
    title: "შეკვეთის შეყვანა",
    inputLabel: "ჩასვით შეკვეთის ტექსტი",
    placeholder: "ტექსტი ჩასვით აქ",
    processButton: "შეყვანა",
    flowGuide: {
      paste: "ჩასვით",
      process: "დაამუშავეთ",
      results: "ნახეთ შედეგები",
    },
    processing: "მუშავდება...",
    saveButton: "შეინახე და მარტივად მართე შეკვეთები ერთ სივრცეში",
    tryAnother: "სხვა შეკვეთის ცდა",
    rateLimit: "სადემონსტრაციო ლიმიტი ამოიწურა. დარეგისტრირდი გასაგრძელებლად",
    rateLimitCta: "დარეგისტრირდი უფასოდ",
    emptyInput: "გთხოვ ჩასვი შეკვეთის ტექსტი დასამუშავებლად.",
    processingError: "შეკვეთა ვერ დამუშავდა. სცადეთ ხელახლა.",
    attemptsRemaining: "დარჩენილი მცდელობების რაოდენობა",
    freeTriesRemaining: "უფასო ცდა",
    sampleOrder: `2025 წლის 12 იანვარი

ნიკა • 11:07 გამარჯობაა 🤗 ორ ადგილიანი საწოლი რა ღირს? 2050 × 1500 × 1040 მმ ზომებით

თემო • 11:08 გამარჯობა ნიკა, 950 ლარი

ნიკა • 11:09 850 ლარად მომცემთ? დღესვე გადავიხდი 🙏

თემო • 11:11 850 ლარად მოგცემთ, ქეშად თუ გადაიხდით.

ნიკა • 11:12 დიდი მადლობა. მოწოდება შეგიძლიათ?

თემო • 11:13 დიახ, მისამართი მითხარით თუ შეიძლება.

ნიკა • 11:14 ვაზისუბანი, კახეთის გზატკეცილი N45.

თემო • 11:16 ჩავიწერე. რომელ დღეს გირჩევნიათ?

ნიკა • 11:17 ხვალ, სადღაც 14:00–17:00 შუალედში.

თემო • 11:18 კარგი, ასე დავაფიქსირებ.

თემო • 11:19 ნიკა, ნომერიც დამიტოვეთ, კურიერს გადავცემ.

ნიკა • 11:20 597 12 34 56

თემო • 11:21 მადლობა. ხვალ მოსვლამდე დაგირეკავენ.`,
    results: {
      title: "მონაცემები ამოღებულია",
      timeSaved: "დაზოგილია ~2 წუთი",
      customer: "მომხმარებელი",
      phone: "ტელეფონი",
      address: "მისამართი",
      products: "პროდუქტი",
      price: "ფასი",
    },
  },
  thankYou: {
    title: "განაცხადი მიღებულია!",
    subtitle: "მადლობა დაინტერესებისთვის! მივიღეთ თქვენი განაცხადი და განვიხილავთ მას 24-48 საათში.",
    whatHappensNext: "რა მოხდება შემდეგ?",
    steps: {
      verification: {
        title: "გადავამოწმებთ თქვენს ინფორმაციას",
        description: "ჩვენი გუნდი განიხილავს თქვენი ბიზნესის დეტალებს და დარწმუნდება, რომ ყველაფერი რიგზეა.",
      },
      review: {
        title: "განხილვა 24-48 საათში",
        description: "მიიღებთ ელ-ფოსტას ჩვენი გადაწყვეტილებით და შემდეგი ნაბიჯებით.",
      },
      password: {
        title: "პაროლის დაყენება",
        description: "დამტკიცების შემდეგ მიიღებთ ბმულს პაროლის დასაყენებლად.",
      },
      access: {
        title: "OrderFlow-ის გამოყენება",
        description: "პაროლის დაყენების შემდეგ შეძლებთ შესვლას და შეკვეთების მართვას.",
      },
    },
    note: {
      title: "მნიშვნელოვანი",
      description:
        "გთხოვთ შეამოწმოთ თქვენი ელ-ფოსტის საფოსტო ყუთი (და spam საქაღალდე) განაცხადის სტატუსის შესამოწმებლად.",
    },
    buttons: {
      backHome: "მთავარზე დაბრუნება",
      signIn: "შესვლა",
    },
    support: {
      question: "გაქვთ კითხვები?",
      contactUs: "დაგვიკავშირდით",
    },
  },
  // Progressive Onboarding - Explore flow (email-only entry)
  explore: {
    title: "გაეცანით OrderFlow-ს",
    subtitle: "შეიყვანეთ ელფოსტა სისტემის საცდელად.",
    noSetup: "კონფიგურაცია არ არის საჭირო, ვალდებულება არ არის.",
    continue: "გაგრძელება",
    passwordLater: "პაროლს მოგვიანებით დააყენებთ.",
    alreadyHaveAccount: "უკვე გაქვთ ანგარიში?",
    loginLink: "შესვლა",
    login: "შესვლა",
    trialInfo: "14 დღიანი სატესტო რეჟიმი · ბარათის გარეშე · შეწყვეტა ნებისმიერ დროს",
    accountExists: "ანგარიში უკვე არსებობს",
    accountExistsDesc: "ამ ელფოსტით ანგარიში უკვე არსებობს. გთხოვთ შეხვიდეთ სისტემაში.",
    success: "ანგარიში შექმნილია",
    successSetPassword: "გთხოვთ დააყენოთ პაროლი გასაგრძელებლად.",
    welcome: "კეთილი იყოს თქვენი მობრძანება!",
    welcomeDesc: "თქვენ მზად ხართ OrderFlow-ს გასაცნობად.",
    error: "რაღაც შეცდომა მოხდა",
  },
  // Secure Account Banner & Modal
  secureAccount: {
    title: "დაიცავი ანგარიში",
    description: "დააყენე პაროლი ადვილად შესასვლელად. ან გამოიყენე 'დაგავიწყდათ პაროლი' შესვლის ბმულის მისაღებად.",
    emailLabel: "შესვლის ბმული მოვა",
    setPassword: "პაროლის დაყენება",
    later: "მოგვიანებით",
    createTitle: "შექმენი პაროლი",
    createDescription: "ეს იცავს შენს ანგარიშს და საშუალებას გაძლევს ნებისმიერ დროს შეხვიდე.",
    password: "პაროლი",
    confirmPassword: "პაროლის დადასტურება",
    save: "პაროლის შენახვა",
    saving: "ინახება...",
    success: "პაროლი წარმატებით შეინახა",
    noPasswordYet: "ამ ანგარიშს ჯერ პაროლი არ აქვს",
    setToLogin: "პაროლის დაყენება შესასვლელად",
    setToLoginDesc: "თქვენ დაიწყეთ გამოცდა პაროლის გარეშე. ახლა დააყენეთ შესასვლელად.",
    passwordSetSuccess: "პაროლი წარმატებით დაყენდა",
    passwordSetSuccessDesc: "ახლა შეგიძლიათ შეხვიდეთ ელფოსტით და პაროლით.",
  },
  landing: {
    // Calm Utility Landing - Single Column Mobile-First Design
    hero: {
      headline: "მიიღე შეკვეთები. გაუგზავნე კურიერს. ქაოსის გარეშე.",
      subheadline: "მესიჯებიდან მზა შეკვეთებამდე — ერთ სივრცეში.",
      cta: "ნახე როგორ მუშაობს",
    },
    signIn: "შესვლა",
    // Features section (2 blocks + 1 quiet AI line)
    features: {
      intake: {
        title: "მიიღე შეკვეთები ბმულით",
        description: "შეკვეთები მოდის გასაგებად და მზად გასაგზავნად.",
      },
      courier: {
        title: "გაუგზავნე შეკვეთები კურიერს",
        description: "შენი კურიერი ხედავს ყველაფერს და აღნიშნავს მიწოდებულს.",
      },
      aiWhisper: "ჩატშია შეკვეთები? ჩასვი — OrderFlow თვითონ შეავსებს.",
    },
    // V2 — ერთი მშვიდი ფასების ბარათი
    v2Pricing: {
      eyebrow: "ერთი ფასი · ყველაფერი შედის",
      price: "39",
      currency: "₾",
      period: "/ თვე",
      tagline: "ყველაფერი, რაც მშვიდად შეკვეთების სამართავად გჭირდება. ტარიფების გარეშე.",
      bullets: [
        "მართე ყველა შეკვეთა ერთ სივრცეში",
        "გაგზავნე მიტანები ზედმეტი მიმოწერის გარეშე",
        "ჩატის მესიჯები აქციე ნამდვილ შეკვეთებად",
      ],
      cta: "ნახე როგორ მუშაობს",
    },
    // Create Order Link Modal
    createLink: {
      step1Title: "შენი შეკვეთის ფორმა მზადაა",
      step1Subtitle: "ასე გამოიყურება მომხმარებლისთვის",
      product: "პროდუქტი",
      price: "ფასი",
      quantity: "რაოდენობა",
      customerName: "მომხმარებლის სახელი",
      customerPhone: "ტელეფონი",
      customerAddress: "მისამართი",
      customerNotes: "შენიშვნა",
      optional: "არასავალდებულო",
      generateButton: "შექმენი ჩემი ბმული",
      editForm: "ფორმის რედაქტირება",
      step2Title: "ბოლო ნაბიჯი",
      step2Subtitle: "შეიყვანე ელფოსტა ბმულის მისაღებად",
      emailPlaceholder: "your@email.com",
      continueButton: "გაგრძელება",
      step3Title: "შენი შეკვეთის ბმული მზადაა!",
      step3Subtitle: "გაუზიარე ეს ბმული მომხმარებლებს",
      copyLink: "კოპირება",
      openForm: "ფორმის გახსნა",
      continueSetup: "პარამეტრებზე გადასვლა →",
      copied: "ბმული დაკოპირდა!",
      errorAccountExists: "ანგარიში უკვე არსებობს. გთხოვთ შეხვიდეთ.",
      errorGeneric: "რაღაც შეცდომა მოხდა. სცადეთ თავიდან.",
      loading: "მზადდება...",
    },
    nav: {
      menu: "მენიუ",
      about: "ჩვენ შესახებ",
      howItWorks: "როგორ მუშაობს",
      pricing: "ფასები",
    },
    // Local Trust Bar - Simple line
    localTrust: {
      builtFor: "შექმნილია ქართული ბიზნესისთვის",
      worksWithWorkflow: "აუმჯობესებს თქვენს არსებულ პროცესებს",
    },
    // Pain Recognition Section - Blunt problems
    pain: {
      headline: "გეცნობათ?",
      messages: "მიმოფანტული შეტყობინებები და ჩანაწერები",
      calling: "ზარები და მიმოწერები მთელი დღე",
      lostOrders: "არეული მისამართი, ან გაუგებარი შეკვეთები",
      noStatus: "გაურკვეველი მიტანის სტატუსი",
    },
    // Linear Flow Section - Simple pipeline with 5 steps
    flow: {
      headline: "როგორ მუშაობს",
      orderIn: "ამატებთ შეკვეთას",
      orderInMethods: "OrderFlow-ს შეკვეთის ფორმა · ჩატის მიმოწერა · ხელით · მასობრივად",
      organizes: "OrderFlow აწესრიგებს",
      organizesMethods: "დღეს · ხვალ · ამ კვირაში",
      shareLink: "შეკვეთებს უზიარებთ კურიერს",
      delivers: "კურიერს მიაქვს შეკვეთები",
      deliversMethods: "კურიერი · პარტნიორი · ფოსტა · თვითგატანა",
      logged: "ეს ყველაფერი იწერება პროგრამაში",
      loggedMethods: "ქრონოლოგია · სტატუსი · შენიშვნები · ისტორია",
      bonus: {
        liveSync: "ლაივ სინქრონიზაცია",
        sharedLog: "საერთო ჟურნალი",
        liveStatuses: "ლაივ სტატუსები",
      },
    },
    // Demo UI translations
    demo: {
      tryItPrompt: "ჩასვი შეტყობინება Viber-დან ან WhatsApp-დან. ნახე როგორ მუშაობს.",
      needsAttention: "საჭიროებს ყურადღებას",
      today: "დღევანდელი",
      tableHeaders: {
        note: "შენიშვნა",
        session: "სესია",
        customer: "მომხმარებელი",
        product: "პროდუქტი",
        status: "სტატუსი",
        log: "ჩანაწერი",
      },
      statuses: {
        New: "ახალი",
        Processing: "მუშავდება",
        Ready: "მზადაა",
        "Out for Delivery": "გზაშია",
        Delivered: "მიტანილია",
        "Delivery Failed": "ვერ მოხერხდა",
        Cancelled: "გაუქმებულია",
      },
      // Courier Flow
      ordersSelected: "შეკვეთა მონიშნულია",
      generateLink: "ბმულის შექმნა",
      linkReady: "ბმული მზადაა",
      orders: "შეკვეთები",
      expires: "ვადა",
      endOfDay: "დღის ბოლომდე",
      deliveryList: "მიტანის სია",
      liveSync: "ლაივ სინქრო",
      updated: "განახლდა",
      startDelivery: "მიტანის დაწყება",
      delivered: "მიტანილია",
      // Shared Log
      managerView: "მენეჯერის ხედი",
      courierView: "კურიერის ხედი",
      history: "ისტორია",
      // Order Intake
      linkCreated: "ბმული შეიქმნა",
      shareOn: "გაუზიარეთ Instagram/WhatsApp-ზე",
      familyBakery: "საოჯახო პური",
      orderForm: "შეკვეთის ფორმა",
      formLabels: {
        name: "სახელი *",
        phone: "ტელეფონი *",
        address: "მისამართი *",
        quantity: "რაოდენობა",
        note: "შენიშვნა",
        optional: "არასავალდებულო",
        pieces: "ცალი",
      },
      submit: "გაგზავნა",
      // Planning Radar
      upcoming: "მომავალი",
      tomorrow: "ხვალ",
      // Sample data (Georgian versions - same as before)
      sampleNames: {
        george: "გიორგი მამულაშვილი",
        anna: "ანა გელაშვილი",
        nino: "ნინო ბერიძე",
        david: "დავით კვარაცხელია",
        mariam: "მარიამ თოფურია",
        levan: "ლევან გიორგაძე",
        tekla: "თეკლა ჯავახიშვილი",
      },
      sampleAddresses: {
        vake: "ვაკე, აბაშიძის 12",
        isani: "ისანი, ნავთლუღის 23",
        saburtalo: "საბურთალო, პეკინის 45",
        didube: "დიდუბე, წერეთლის 78",
        gldani: "გლდანი, ხიზანიშვილის 5",
        nadzaladevi: "ნაძალადევი, გურამიშვილის 12",
      },
      sampleProducts: {
        shirt: "პერანგი",
        jacket: "ქურთუკი",
        bag: "ჩანთა",
        shoes: "ფეხსაცმელი",
        watch: "საათი",
        dress: "კაბა",
        belt: "ქამარი",
        coat: "პალტო",
      },
      sampleAlerts: {
        delayedDelivery: "გადავადებული მიწოდება",
        clientNotResponding: "კლიენტი არ პასუხობს",
        orderWaiting: "შეკვეთა დალოდინებაშია",
      },
      sampleLogs: {
        orderReceived: "შეკვეთა მიღებულია",
        readyForDelivery: "მზადაა მიტანისთვის",
        handedToCourier: "კურიერს გადაეცა",
        confirmed: "დადასტურებულია",
        inTransit: "გზაშია",
        deliveredCheck: "ჩაბარდა ✓",
        paidCash: "ნაღდით გადაიხადა",
        trafficDelay: "საცობია, 10 წუთში მივიტან",
        warehousePreparing: "საწყობი ამზადებს შეკვეთას, ხვალ გაიარე",
        secondFloorApt8: "კარგი, მეორე სართულზე უნდა დატოვო, ბინა 8",
        deliveredPaidCash: "ჩაბარებულია, ნაღდით გადაიხადა",
        orderCreated: "შეკვეთა შეიქმნა",
        readyIn2Hours: "მაკომ 2 საათზე იქნება მზადო, საწყობში",
        pickedUpInVake: "ავიღე, ვაკეში ვარ უკვე",
        leftWithNeighbor: "მეზობელთან დავტოვე",
      },
      courier1: "კურიერი 1",
      courier2: "კურიერი 2",
      contextPriority: "პრიორიტეტი",
    },
    // Product Preview Section - Now demo components
    preview: {
      label: "პროდუქტი",
      headline: "რას ნახავთ შიგნით",
      subheadline: "რეალური ინტერფეისი, რეალური ბიზნესისთვის",
      boardHeadline: "ბიზნესის საერთო ხედი",
      boardDescription: "ერთი შეხედვით ნახეთ რა საჭიროებს ყურადღებას და რა მიმდინარეობს ახლა.",
      courierHeadline: "მენეჯერიდან კურიერამდე",
      courierDescription: "ერთი ბმულით უზიარებით მზა შეკვეთების სიას კურიერს. არანაირი Viber, არანაირი გაურკვევლობა.",
      planningHeadline: "მომავალი შეკვეთები — რომ არ გამოგრჩეთ მიტანის დღე",
      planningDescription: "ხვალინდელი და შემდეგი დღეების მარტივი შემოწმება",
      intakeHeadline: "გარე შეკვეთები — შეკვეთების მიღების ინოვაციური გზა",
      intakeDescription:
        "გაუზიარეთ ბმული მომხმარებელს. მიიღეთ მოწესრიგებული შეკვეთა საბანკო გადმორიცხვის ან ხელზე გადახდის შესაძლებლობით.",
      orderList: "შეკვეთების სია",
      statusChange: "სტატუსის ცვლილება",
      deliveryLog: "მიტანის ისტორია",
      liveSync: "ლაივ სინქრონიზაცია",
      dashboard: "დეშბორდი",
      courierView: "კურიერის ხედი",
      courierFlow: "მენეჯერი → კურიერი",
      planning: "მომავალი შეკვეთები",
    },
    // Shared Log Section - Key Differentiator
    sharedLog: {
      label: "მთავარი განსხვავება",
      headline: "ერთ საერთო ჟურნალში აღმოფხვრილი გაურკვევლობა.",
      description:
        "მენეჯერი ხედავს სრულ სურათს — კურიერი მხოლოდ საჭიროს. უსასრულო Viber მიმოწერების და დაკარგული მესიჯების ნაცვლად.",
      point1: "ერთი მიწოდების/შეკვეთის ჟურნალი",
      point2: "მართვა ერთ, ლაივ სივრცეში",
      replacesViber: "ეს ანაცვლებს Viber-ს და აწესრიგებს მიტანის მენეჯმენტს.",
      mockup: {
        manager: "მენეჯერი",
        managerAction: "შეკვეთა გადაცემულია კურიერს",
        courier: "კურიერი",
        courierAction: "მისამართზე მივედი",
        system: "სისტემა",
        systemAction: "✓ მიტანილია",
      },
    },
    // Who It's For Section
    whoItsFor: {
      headline: "ეს პროგრამა შენთვისაა?",
      goodForLabel: "კარგია თუ გაქვთ",
      notForLabel: "არ არის კარგი თუ გაქვთ",
      good1: "პატარა მაღაზია ან ონლაინ ვაჭრობა",
      good2: "სწრაფი კვების რესტორანი",
      good3: "სარემონტო ბიზნესი ან სერვის ცენტრი",
      good4: "თუ კი დღეში 10 და მეტი შეკვეთა გაქვთ",
      not1: "მსხვილი და კომპლექსური ბიზნესი",
    },
    // Final CTA - Low commitment
    finalCta: {
      headline: "ნახე OrderFlow მოქმედებაში.",
      subheadline: "შემოდი და გამოსცადე ცოცხალი დემო შეკვეთით.",
      button: "ნახე როგორ მუშაობს",
      disclaimer: "შექმნილია საქართველოში 🇬🇪 · ყოველდღიურად გამოიყენება ლოკალური ბიზნესების მიერ.",
    },
    // Pricing Section - 3-tier structure
    pricing: {
      label: "ფასები",
      headline: "ფასები, რომლებიც იზრდება თქვენს ბიზნესთან ერთად",
      subheadline: "ფუნქციების შეზღუდვა არ ხდება. ზრდისთვის ჯარიმა არ არის. მხოლოდ მკაფიო პირობები.",
      currency: "₾",
      period: "/ თვე",

      // Tier: Starter
      starter: {
        name: "სტარტერ",
        price: "39",
        tagline: "მცირე, დაბალი მოცულობის ოპერაციებისთვის",
        description: "სრული შეკვეთების მართვა, როცა OrderFlow სასარგებლოა, მაგრამ ჯერ არ არის ბიზნესისთვის კრიტიკული.",
        capacity: "განკუთვნილია ~0-150 შეკვეთა/თვეში",
      },
      // Tier: Growth
      growth: {
        name: "ზრდა",
        price: "79",
        tagline: "ბიზნესებისთვის, რომლებიც OrderFlow-ზე ყოველდღიურ ოპერაციებს აწარმოებენ",
        description: "იგივე ფუნქციები, მეტი ოპერაციული კომფორტი, როცა ერთი ბმული აღარ არის საკმარისი.",
        capacity: "განკუთვნილია ~150-800 შეკვეთა/თვეში",
        badge: "რეკომენდებული",
      },
      // Tier: Unlimited
      unlimited: {
        name: "პრო",
        price: "129",
        tagline: "მაღალი მოცულობის, ბიზნესისთვის კრიტიკული გამოყენებისთვის",
        description: "შექმნილია მასშტაბის, სიჩქარის და ნულოვანი ხახუნისთვის.",
        capacity: "განკუთვნილია 800+ შეკვეთა/თვეში",
      },

      // Shared feature labels
      features: {
        orderManagement: "სრული შეკვეთების მართვა და თვალყურის დევნება",
        customerTracking: "კლიენტის და გადახდის სტატუსის თვალყურის დევნება",
        deliveryFlow: "მიტანის ნაკადი და გარე მიღება ჩართულია",
        deliveryLink: "მიტანის ბმული",
        deliveryLinks: "მიტანის ბმული",
        intakeForm: "გარე შეკვეთის მიღების ფორმა",
        intakeForms: "გარე შეკვეთის მიღების ფორმა",
        logsHistory: "ლოგები და შეკვეთების ისტორია",
        everything: "ყველაფერი სტარტერიდან",
        unlimitedLinks: "შეუზღუდავი მიტანის ბმულები",
        unlimitedForms: "შეუზღუდავი გარე შეკვეთის ფორმები",
        noCeiling: "შეკვეთების რეკომენდებული ზღვარი არ არის",
      },

      // Quantities
      quantity: {
        one: "1",
        upToFive: "5-მდე",
        unlimited: "შეუზღუდავი",
      },

      // Trust builder section
      trust: {
        headline: "მნიშვნელოვანი",
        point1: "ჩვენ არასდროს ვბლოკავთ ფუნქციებს თუ თქვენი პაკეტზე სწრაფად იზრდებით",
        point2: "ჩვენ გაცნობებთ, არა დაგსჯით",
        point3: "პაკეტის ცვლილება მოქმედებს მომდევნო ბილინგის ციკლიდან",
      },

      // Emotional tagline
      tagline: "OrderFlow არ აჩერებს თქვენს ბიზნესს როცა წარმატებას აღწევთ.",

      // FAQ section
      faq: {
        label: "ფასების FAQ",
        items: {
          usage: {
            q: "როგორ ითვლით შეკვეთების მოცულობას?",
            a: "ვითვლით შეკვეთების ჯამს თვეში. პაკეტები არის რეკომენდაცია და არა მკაცრი ლიმიტი.",
          },
          exceed: {
            q: "რა მოხდება თუ პაკეტის რეკომენდებულ ზღვარს გადავაჭარბებ?",
            a: "არაფერი დაირღვევა. უბრალოდ გაცნობებთ და შემოგთავაზებთ უკეთეს პაკეტს მომდევნო ბილინგის ციკლიდან.",
          },
          change: {
            q: "როდის ამოქმედდება პაკეტის ცვლილება?",
            a: "პაკეტის ცვლილება ამოქმედდება მომდევნო ბილინგის ციკლიდან.",
          },
          links: {
            q: "რა განსხვავებაა მიტანის ბმულსა და შეკვეთების მიღების ფორმას შორის?",
            a: "მიტანის ბმული გამოიყენება კურიერისთვის სტატუსის განახლებისა და კონტროლისთვის. მიღების ფორმა არის გარე ბმული, რომლითაც კლიენტი აკეთებს შეკვეთას.",
          },
          starterLimits: {
            q: "ყველა პაკეტში არის მიტანა და გარე მიღების ფუნქცია?",
            a: "დიახ. სტარტერში შედის 1 მიტანის ბმული და 1 მიღების ფორმა. უფრო მაღალ პაკეტებში არის მრავალი ან შეუზღუდავი.",
          },
          cancel: {
            q: "შეგიძლიათ ნებისმიერ დროს გაუქმება?",
            a: "დიახ. წვდომა გექნებათ მიმდინარე ბილინგის პერიოდის ბოლომდე.",
          },
        },
      },
    },
    // About Us (comprehensive company profile)
    aboutUs: {
      // Section 1: What OrderFlow Does
      whatWeDoLabel: "რას აკეთებს OrderFlow",
      whatWeDoText:
        "OrderFlow არის ვებ-აპლიკაცია (პროგრამა) მცირე და საშუალო ბიზნესებისთვის საქართველოში, რომელიც აერთიანებს და ამარტივებს შეკვეთების მიღებას, დამუშავებას, მიტანის ორგანიზებასა და კომუნიკაციას ერთ სისტემაში.",
      // Section 2: Who It's For
      whoItsForLabel: "ვისთვის არის შექმნილი",
      whoItsForText:
        "პლატფორმა განკუთვნილია ონლაინ მოვაჭრეებისთვის, მცირე მაღაზიებისთვის, საწყობების მქონე ბიზნესებისთვისა და მცირე და საშუალო დისტრიბუტორებისთვის, რომლებიც იღებენ შეკვეთებს სოციალური ქსელებიდან და მესენჯერებიდან, ან შეკვეთის მიღების პროცესის გაუმჯობესება სურთ OrderFlow-ს ინოვაციური შეკვეთის მიღების ბმულის (ფორმის) გამოყენებით.",
      // Section 3: Product Stage
      stageLabel: "რა ეტაპზეა პროდუქტი",
      stageText:
        "პროდუქტი არის აქტიურ გამოყენებაში, ფუნქციონალური ტესტირების (MVP) ფაზაში, და მუდმივად ვითარდება რეალური მომხმარებლების გამოხმაურების საფუძველზე.",
      // Section 4: Team
      teamLabel: "გუნდი",
      teamFounder:
        "OrderFlow-ს დამფუძნებელია ჯაბა ცენტერაძე — ტექნოლოგიებისა და ბიზნეს ანალიტიკის მიმართულებით მრავალწლიანი გამოცდილების მქონე პროფესიონალი, რომელსაც უმუშავია როგორც კორპორატიულ, ასევე მცირე და საშუალო ბიზნეს გარემოში.",
      teamMembers:
        "ასევე OrderFlow-ს გუნდის წევრები არიან მრავალწლიანი გამოცდილების მქონე ფინანსური დირექტორი და მარკეტინგის და მომხმარებლებთან ურთიერთობის სპეციალისტი.",
      // Section 5: Closing Statement
      closingText:
        "პროექტი იქმნება რეალური ოპერაციული გამოცდილების საფუძველზე და მიზნად ისახავს მცირე ბიზნესებისთვის ყოველდღიური პროცესების გამარტივებას.",
    },
    // Footer contact info
    footer: {
      phone: "ტელეფონი",
      email: "ელ-ფოსტა",
      followUs: "სოციალური ქსელები",
    },
    // Footer
    company: {
      name: "OrderFlow",
      founded: "დაფუძნებულია 2025 წელს",
      location: "ბათუმი, საქართველო",
      mission: "ვეხმარებით ქართულ მცირე და საშუალო ბიზნესს დაზოგონ დრო ჭკვიანი შეკვეთების მართვით",
      contact: "კონტაქტი: info@orderflow.ge",
    },
    madeInTbilisi: "საქართველოში",
    georgianSupport: "შექმნილი საქართველოში",
  },
  onboarding: {
    welcome: {
      title: "კეთილი იყოს თქვენი მობრძანება OrderFlow-ში!",
      subtitle: "მოდით, სწრაფად გავეცნოთ აპლიკაციას",
      startTour: "ტურის დაწყება",
      skip: "გამოტოვება ახლა",
      timeEstimate: "დაახლოებით 2 წუთი სჭირდება",
    },
    steps: {
      smartVsManual: {
        title: "შეკვეთების დამატების ორი გზა",
        subtitle: "აირჩიეთ მეთოდი, რომელიც თქვენთვის საუკეთესოა",
        whyMatters: "დაზოგეთ 10+ წუთი დღეში სწორი არჩევანით",
        smartTitle: "ჭკვიანი შეყვანა",
        smartDesc:
          "დააკოპირეთ შეთანხმებული შეკვეთა ჩატიან, ჭკვიანი ფუნქცია ავტომატურად დაალაგებს ყველაფერს შესაბამისი ველების მიხედვით",
        smartBadge: "⚡ უსწრაფესი",
        smartFeature1: "კოპი-პასტი, პირდაპირ ჩასვით შეტყობინებები",
        smartFeature2: "ჭკვიანი ფუნქცია ამოიღებს ყველა მნიშვნელოვან დეტალს",
        smartSpeed: "5-10 წამი შეკვეთაზე",
        manualTitle: "ხელით შევსება",
        manualDesc: "შეავსეთ ფორმა ხელით",
        manualBadge: "🎯 მეტი კონტროლი",
        manualFeature1: "სრული შეყვანის კონტროლი",
        manualFeature2: "იდეალურია თუ კი შეკვეთა მაგალითად, ფურცელზე გიწერიათ",
        manualSpeed: "1-2 წუთი შეკვეთაზე",
      },
      workflow: {
        title: "თქვენი ყოველდღიური სამუშაო",
        subtitle: "სამი სექცია გეხმარებათ ფოკუსირებასა და ორგანიზებაში",
        whyMatters: "არასოდეს გამოტოვოთ ვადაგასული შეკვეთა",
        needsAttention: "საჭიროებს ყურადღებას",
        needsAttentionDesc: "წინა დღეების შეკვეთები, რომლებიც ვერ დაასრულეთ და ყურადღებას საჭიროებენ",
        today: "დღეს",
        todayDesc: "დღევანდელი შეკვეთები ეტაპების მიხედვით",
        todayStages: "ახალი → მზადაა → გზაში → მიტანილი",
        history: "ისტორია",
        historyDesc: "წინა დღეების შეკვეთები",
      },
      deliveryManagement: {
        title: "მიტანის მართვა",
        subtitle: "ორგანიზებული მიტანა და გაზიარება კურიერებთან",
        whyMatters: "თვალყური ადევნეთ ყველა შეკვეთას საწყობიდან კარამდე",
        sessionsTitle: "დისპეჩერული სესიები",
        sharingTitle: "კურიერთან გაზიარება",
        feature1: "'მზადაა' სტატუსის შეკვეთების დაჯგუფება",
        feature2: "სესიის პროგრესის რეალურ დროში თვალყურის დევნება",
        feature3: "ერთი დაწკაპუნებით ბმულის გაზიარება კურიერთან",
        feature4: "კურიერი ხედავს მხოლოდ საჭირო ინფორმაციას",
      },
      sessions: {
        title: "მიტანის სესიები",
        subtitle: "ორგანიზებულად მართეთ მიტანის რეისები",
        feature1: "'მზადაა' სტატუსის შეკვეთების დაჯგუფება მიტანის პარტიებად",
        feature2: "ერთი დაწკაპუნებით ბმულის გაზიარება კურიერთან",
        feature3: "სესიის პროგრესის რეალურ დროში თვალყურის დევნება",
        feature4: "შეკვეთები ავტომატურად იბლოკება მინიჭების შემდეგ",
      },
      upcomingDeliveries: {
        title: "მომავალი მიტანები",
        subtitle: "დაგეგმილი მიტანების თვალყურის დევნება",
        feature1: "იხილეთ ყველა მომავალი შეკვეთა მიტანის თარიღით",
        feature2: "ხვალინდელი შეკვეთები ავტომატურად გამოჩნდება 'საჭიროებს ყურადღებას'-ში",
        feature3: "ვიზუალური სტატუსი: ვადაგასული, დღეს, ხვალ",
        feature4: "ძიება და გაფართოებული ხედვა სწრაფი წვდომისთვის",
      },
      deliverySharing: {
        title: "გაუზიარეთ კურიერებს",
        subtitle: "შექმენით მიტანის ბმული კურიერისთვის",
        feature1: "დააჭირეთ 🔗 გაზიარების ღილაკს ბმულის შესაქმნელად",
        feature2: "აირჩიეთ მზა შეკვეთები რომ დაემატოს აქტიური შეკვეთების ნუსხას",
        feature3: "კურიერი ხედავს მხოლოდ მიტანისთვის საჭირო ინფორმაციას",
        feature4: "თვალყური ადევნეთ მიტანის პროგრესს რეალურ დროში",
      },
      exportAnalytics: {
        title: "ექსპორტი და ანალიტიკა",
        subtitle: "სტიკერები და ბიზნეს სტატისტიკა",
        stickersTitle: "სტიკერების ვორდში ექსპორტი და დაბეჭდვა",
        stickersDesc: "მორგებადი სტიკერები კურიერებისთვის ინფორმატიული ხატულებით",
        emojiExamples: "მისამართი • ტელეფონი • ფასი • კლიენტი",
        dashboardTitle: "სტატისტიკა",
        dashboardDesc: "შემოსავლის ტენდენციები, შეკვეთების ანალიტიკა და ტოპ კლიენტები",
      },
      getStarted: {
        title: "მზად ხართ დასაწყებად?",
        subtitle: "აირჩიეთ, როგორ გსურთ თქვენი პირველი შეკვეთის დამატება",
        manual: "შევქმნა ჩემი პირველი შეკვეთა",
        smart: "ჭკვიანი შეყვანა",
        bulk: "ატვირთე ექსელის ფაილი",
        exportHint: "სტიკერების ბეჭდვა",
        dashboardHint: "სტატისტიკის ნახვა",
      },
    },
    checklist: {
      title: "დაწყება",
      createOrder: "შექმენით პირველი შეკვეთა",
      createOrderHint: "გამოიყენეთ ჭკვიანი შეყვანა ან ხელით შევსება",
      markReady: "მონიშნეთ შეკვეთა 'მზადაა'",
      markReadyHint: "შეცვალეთ შეკვეთის სტატუსი 'მზადაა მისატანად'",
      viewArchive: "ნახეთ არქივი",
      viewArchiveHint: "ნახეთ სად ინახება დასრულებული შეკვეთები",
      viewDashboard: "ნახეთ ანალიტიკა",
      viewDashboardHint: "ეწვიეთ სტატისტიკის გვერდს თქვენი ბიზნეს მაჩვენებლების სანახავად",
      complete: "მზად ხართ!",
      completeMessage: "თქვენ დაეუფლეთ OrderFlow-ის საფუძვლებს",
    },
    emptyState: {
      headline: "ჯერ შეკვეთები არ იძებნება - მოდით შევქმნათ პირველი შეკვეთა!",
      description: "აირჩიეთ როგორ გსურთ შეკვეთების დამატება სისტემაში",
      helpText: "დახმარება გჭირდებათ? გადაატარეთ მაუსის ისარი ბარათებზე მეტი ინფორმაციის მისაღებად",
      demoPrompt: "გინდა ჯერ ნახო როგორ მუშაობს?",
      demoButton: "სადემონსტრაციო შეკვეთის შექმნა",
      demoSuccess: "სადემონსტრაციო შეკვეთა შეიქმნა! ნახე როგორ გამოჩნდება სიაში.",
      deleteDemoOrders: "სადემონსტრაციო შეკვეთის წაშლა",
      demoDeleteSuccess: "სადემონსტრაციო შეკვეთები წაიშალა",
      cards: {
        manual: {
          title: "ხელით შევსება",
          description: "თუ კი უფრო კომფორტულია, შეავსეთ მარტივი ფორმა ტრადიციულად, ხელით",
          badge: "ტრადიციული",
        },
        smart: {
          title: "ჭკვიანი შეყვანა",
          description: "ჩასვით Facebook Messenger, Viber/WhatsApp შეტყობინებები - AI შეასრულებს სამუშაოს",
          badge: "⚡ რეკომენდებული",
        },
        excel: {
          title: "Excel ატვირთვა",
          description: "ატვირთეთ ჩატის ექსელ ფაილი შეკვეთების მასობრივი დამატებისთვის",
          badge: "მასობრივი",
        },
        paste: {
          title: "სმარტ ჩასმა",
          description: "დააკოპირეთ და ჩასვით რამდენიმე შეკვეთა ერთდროულად",
          badge: "სწრაფი",
        },
        dashboard: {
          title: "იხილეთ სტატისტიკა",
          description: "შეისწავლეთ თქვენს ბიზნესთან დაკავშირებული სტატისტიკა",
          badge: "",
        },
        sample: {
          title: "ჩამოტვირთეთ ნიმუში",
          description: "იხილეთ Excel ფორმატის მაგალითი",
          badge: "",
        },
      },
    },
    featureComparison: {
      title: "🤔 რომელი მეთოდი უნდა გამოიყენოთ?",
      smartTitle: "ჭკვიანი შეყვანა",
      smartDesc:
        "პირდაპირ ჩასვით Viber/WhatsApp შეტყობინებები და AI ავტომატურად ამოიღებს ყველაფერს. იდეალური ყოველდღიური შეკვეთების დამუშავებისთვის.",
      smartBadge: "⚡ რეკომენდებული",
      smartSpeed: "5-10 წამი შეკვეთაზე",
      manualTitle: "ხელით შევსება",
      manualDesc:
        "შეავსეთ ფორმა ველების მიხედვით, მიიღეთ სრული კონტროლი მონაცემებზე. იდეალურია ტელეფონით შეკვეთებისა და მორგებულად შეყვანისთვის.",
      manualBadge: "🎯 ზუსტი",
      manualSpeed: "1-2 წუთი შეკვეთაზე",
    },
    tips: {
      afterFirstManual:
        "💡 რჩევა: იცოდით, რომ შეგიძლიათ პირდაპირ ჩასვათ Viber შეტყობინებები სმარტ შეყვანის გამოყენებით? სცადეთ შემდეგ ჯერზე დროის დაზოგვისთვის!",
      after10Manual:
        "⚡ დროის დამზოგველი: თქვენ შექმენით 10 შეკვეთა ხელით. გაითვალისწინეთ მასობრივი ატვირთვა რამდენიმე შეკვეთის ერთდროულად დასამუშავებლად!",
      after50Orders: "🎉 კარგად გაართვით თავი! გადადით დაფაზე, რომ ნახოთ თქვენი ანალიტიკა",
      archiveEmpty:
        "დაარქივეთ შეკვეთები აქ, რომ მთავარი სია სუფთა და მოწესრიგებული გქონდეთ. დაარქივებულ შეკვეთებს ნებისმიერ დროს აღადგენთ.",
    },
    dontShowAgain: "აღარ მაჩვენო",
    markComplete: "დასრულებულად მონიშვნა",
  },
  archive: {
    intro: "არქივი — დასრულებული და გაუქმებული შეკვეთები. ისინი აქ რჩება საძიებლად, რომ „შეკვეთები“ აქტიურზე იყოს ფოკუსირებული.",
    introDismiss: "გასაგებია",
    autoArchiveBadge: "ავტო-დაარქივება {{days}} დღის შემდეგ",
    autoArchiveBadgeAction: "შეცვლა",
    groups: {
      thisWeek: "ამ კვირას",
      thisMonth: "ამ თვეს",
      lastMonth: "გასულ თვეს",
      olderThisYear: "უფრო ძველი ამ წელს",
    },
  },
  privacyPolicy: {
    title: "კონფიდენციალურობის პოლიტიკა",
    lastUpdated: "ბოლო განახლება: 15.11.2025",
    backToHome: "მთავარ გვერდზე დაბრუნება",
    sections: {
      introduction: {
        title: "1. შესავალი",
        content:
          'OrderFlow (შემდგომში „ჩვენ" ან „კომპანია") დიდ მნიშვნელობას ანიჭებს თქვენს კონფიდენციალურობას და იღებს პასუხისმგებლობას თქვენი პერსონალური მონაცემების დაცვაზე. წინამდებარე დოკუმენტი განმარტავს, თუ როგორ ვაგროვებთ, ვამუშავებთ და ვიცავთ ინფორმაციას ჩვენი პლატფორმით სარგებლობისას.',
      },
      informationWeCollect: {
        title: "2. ინფორმაციის შეგროვება და კატეგორიები",
        intro: "ჩვენ ვაგროვებთ მხოლოდ იმ ტიპის მონაცემებს, რაც აუცილებელია სერვისის გამართული მუშაობისთვის:",
        youProvide: {
          title: "თქვენ მიერ მოწოდებული ინფორმაცია:",
          items: [
            "ანგარიშის დეტალები: სახელი, გვარი, ელ.ფოსტის მისამართი, ტელეფონის ნომერი, კომპანიის დასახელება",
            "კომერციული მონაცემები: შეკვეთების ისტორია, კლიენტების საკონტაქტო ინფორმაცია (მიღებული ჩატებიდან), პროდუქციის ჩამონათვალი და ფასები",
            "სარეგისტრაციო ინფორმაცია: რეგისტრაციის ან ვერიფიკაციის პროცესში შეყვანილი დამატებითი მონაცემები",
          ],
        },
        automaticallyCollected: {
          title: "ავტომატურად შეგროვებული ინფორმაცია:",
          items: [
            "გამოყენების მონაცემები: როგორ ურთიერთობთ OrderFlow-თან",
            "ტექნიკური მონაცემები: IP მისამართი, ბრაუზერის ტიპი და ვერსია, ოპერაციული სისტემა, მოწყობილობის მონაცემები",
            "სესიის მონაცემები: ინფორმაცია იმის შესახებ, თუ როგორ იყენებთ პლატფორმას (ქუქი-ფაილებისა და ლოგების მეშვეობით)",
          ],
        },
      },
      howWeUse: {
        title: "3. ინფორმაციის გამოყენების მიზნები",
        intro: "თქვენს მონაცემებს ვიყენებთ შემდეგი მიზნებისთვის:",
        items: [
          "OrderFlow-ს სერვისების მიწოდება და ტექნიკური უზრუნველყოფა",
          "ანგარიშის მართვა, მომხმარებლის იდენტიფიკაცია და უსაფრთხოება",
          "ხელოვნური ინტელექტის (AI) მეშვეობით ტექსტური შეტყობინებებიდან შეკვეთების დამუშავება",
          "ბიზნეს ანალიტიკისა და სტატისტიკური რეპორტების გენერირება",
          "თაღლითობის პრევენცია და კიბერუსაფრთხოების უზრუნველყოფა",
          "კანონმდებლობით გათვალისწინებული ვალდებულებების შესრულება",
        ],
      },
      legalBasis: {
        title: "4. დამუშავების სამართლებრივი საფუძლები",
        intro:
          "მონაცემთა დამუშავება ხორციელდება GDPR-ისა და საქართველოს კანონმდებლობის შესაბამისად, შემდეგ საფუძვლებზე დაყრდნობით:",
        items: [
          "ხელშეკრულების შესრულება: მომსახურების გასაწევად",
          "ლეგიტიმური ინტერესი: სერვისის უსაფრთხოებისა და გაუმჯობესებისთვის",
          "თანხმობა: მარკეტინგული შეტყობინებების მისაღებად (რომლის გაუქმება ნებისმიერ დროს შეგიძლიათ)",
          "კანონიერი ვალდებულება: საგადასახადო და სამართლებრივი მოთხოვნების დასაკმაყოფილებლად",
        ],
      },
      dataSharing: {
        title: "5. მონაცემების გაზიარება",
        intro: "ჩვენ არ ვყიდით და არ გადავცემთ თქვენს მონაცემებს არაუფლებამოსილ პირებს. მონაცემებს ვუზიარებთ მხოლოდ:",
        serviceProviders: {
          title: "სერვის პროვაიდერებს:",
          items: [
            "Supabase (მონაცემთა ბაზის ჰოსტინგი)",
            "Google Cloud (AI დამუშავება)",
            "ელ.ფოსტის სერვის პროვაიდერები",
          ],
        },
        other: [
          "სამართლებრივი აუცილებლობა: კანონის, სასამართლო განჩინების ან სახელმწიფო უწყების მოთხოვნის საფუძველზე",
          "ბიზნეს რეორგანიზაცია: კომპანიის შერწყმის ან გასხვისების შემთხვევაში (მონაცემთა კონფიდენციალურობის დაცვის გარანტიით)",
        ],
      },
      dataSecurity: {
        title: "6. მონაცემთა შენახვა და უსაფრთხოება",
        intro: "ჩვენ ვიყენებთ ინდუსტრიის სტანდარტულ უსაფრთხოების ზომებს:",
        items: [
          "დაშიფვრა: მონაცემები დაშიფრულია როგორც გადაცემის პროცესში (TLS 1.3), ასევე სტატიკურ მდგომარეობაში/შენახვისას (AES-256)",
          "სარეზერვო ასლები: ვიყენებთ დაცულ ღრუბლოვან ინფრასტრუქტურას მონაცემთა რეგულარული სარეზერვო კოპირებით (Backups)",
          "წვდომის კონტროლი: მონაცემებზე წვდომა აქვს მხოლოდ მკაცრად განსაზღვრულ, უფლებამოსილ პერსონალს",
        ],
      },
      dataRetention: {
        title: "7. მონაცემთა შენახვის ვადები",
        items: [
          "აქტიური ანგარიშები: მონაცემები ინახება მანამ, სანამ სარგებლობთ ჩვენი სერვისით",
          "ანგარიშის გაუქმების შემდეგ: ფინანსური და ტრანზაქციული მონაცემები ინახება 6 წლის განმავლობაში (საგადასახადო ვალდებულებების გამო)",
          "წაშლა: ვადის გასვლის შემდეგ, მონაცემები ექვემდებარება სრულ და შეუქცევად განადგურებას",
        ],
      },
      yourRights: {
        title: "8. თქვენი უფლებები",
        intro: "GDPR-ისა და საქართველოს კანონმდებლობის მიხედვით, თქვენ გაქვთ უფლება:",
        items: [
          "წვდომა: მოითხოვოთ თქვენი მონაცემების ასლი",
          "გამოსწორება: გამოასწოროთ არასწორი მონაცემები",
          "წაშლა: წაშალოთ თქვენი ანგარიში და მონაცემები",
          "პორტირება: ექსპორტი გაუკეთოთ თქვენს მონაცემებს",
          "წინააღმდეგობა: უარი თქვათ მონაცემთა დამუშავებაზე კონკრეტული მიზნებისთვის",
          "შეზღუდვა: შეზღუდოთ, ის თუ როგორ ვიყენებთ თქვენს მონაცემებს",
        ],
        contact: "ამ უფლებების გამოსაყენებლად დაგვიკავშირდით: info@orderflow.ge",
      },
      internationalTransfers: {
        title: "9. საერთაშორისო ტრანსფერები",
        intro: "თქვენი მონაცემები შეიძლება დამუშავდეს:",
        items: [
          "საქართველო (ძირითადი ოპერაციები)",
          "ევროკავშირი (მონაცემთა ბაზის ჰოსტინგი)",
          "შეერთებული შტატები (AI დამუშავება შესაბამისი უსაფრთხოების ღონისძიებებით)",
        ],
        compliance:
          "ჩვენ უზრუნველვყოფთ, რომ ნებისმიერი ტრანსსასაზღვრო გადაცემა აკმაყოფილებდეს GDPR-ისა და საქართველოს კანონმდებლობის უსაფრთხოების სტანდარტებს.",
      },
      cookies: {
        title: "10. Cookies (ქუქი-ფაილები)",
        intro: 'ჩვენ ვიყენებთ „ქუქი-ფაილებს" მომხმარებლის გამოცდილების გასაუმჯობესებლად:',
        items: ["ავთენტიფიკაცია და უსაფრთხოება", "თქვენი პარამეტრების შენახვა", "სესიის მართვა"],
        management:
          "თქვენ შეგიძლიათ მართოთ ან დაბლოკოთ ქუქიები ბრაუზერის პარამეტრებიდან, თუმცა ამან შესაძლოა შეზღუდოს პლატფორმის ფუნქციონალი.",
      },
      childrenPrivacy: {
        title: "11. არასრულწლოვანთა დაცვა",
        content:
          "OrderFlow არის ბიზნეს ინსტრუმენტი (B2B). ჩვენ შეგნებულად არ ვამუშავებთ 18 წლამდე ასაკის პირთა პერსონალურ მონაცემებს. თუ აღმოვაჩენთ, რომ სისტემაში არასრულწლოვანის მონაცემები მოხვდა, ისინი დაუყოვნებლივ წაიშლება.",
      },
      dataBreaches: {
        title: "12. მონაცემთა დარღვევები",
        content:
          "ინციდენტის დაფიქსირების შემთხვევაში, რომელიც საფრთხეს უქმნის თქვენს უფლებებს, ჩვენ ვალდებულებას ვიღებთ, შეგატყობინოთ თქვენ და შესაბამის საზედამხედველო ორგანოს დარღვევის აღმოჩენიდან არაუგვიანეს 72 საათისა.",
      },
      changesToPolicy: {
        title: "13. ცვლილებები პოლიტიკაში",
        content:
          "OrderFlow უფლებას იტოვებს, განაახლოს წინამდებარე პოლიტიკა. მნიშვნელოვანი ცვლილებების შესახებ გეცნობებათ ელ.ფოსტით ან პლატფორმის შეტყობინების მეშვეობით.",
      },
      contact: {
        title: "14. საკონტაქტო ინფორმაცია",
        intro: "პერსონალურ მონაცემებთან დაკავშირებული ნებისმიერი კითხვის შემთხვევაში, გთხოვთ, დაგვიკავშირდეთ:",
        email: "ელ.ფოსტა: info@orderflow.ge",
        phone: "ტელეფონი: +995 505 051 685",
        dpo: "მონაცემთა დაცვის ოფიცერი:",
        dpoEmail: "ელ.ფოსტა: info@orderflow.ge",
        supervisoryAuthority: "ზედამხედველი ორგანო:",
        authority: "საქართველოს პერსონალურ მონაცემთა დაცვის სამსახური",
        authorityWebsite: "ვებსაიტი: personaldata.ge",
        authorityEmail: "ელ.ფოსტა: office@personaldata.ge",
      },
      acknowledgment:
        "OrderFlow-ის გამოყენებით თქვენ ადასტურებთ, რომ წაიკითხეთ და გაიგეთ ეს კონფიდენციალურობის პოლიტიკა.",
    },
  },
  termsOfService: {
    title: "მომსახურების პირობები",
    lastUpdated: "ბოლო განახლება: 15.11.2025",
    backToHome: "მთავარ გვერდზე დაბრუნება",
    sections: {
      agreementToTerms: {
        title: "1. პირობების მიღება",
        content:
          "OrderFlow-ზე წვდომით ან გამოყენებით თქვენ ეთანხმებით ამ მომსახურების პირობებს. თუ არ ეთანხმებით ამ პირობების რომელიმე ნაწილს, თქვენ არ შეგიძლიათ გამოიყენოთ ჩვენი სერვისი.",
      },
      descriptionOfService: {
        title: "2. სერვისის აღწერა",
        content:
          "OrderFlow უზრუნველყოფს AI-ით ამოქმედებულ შეკვეთების მართვის პლატფორმას, რომელიც ეხმარება ქართულ ბიზნესებს დაამუშაონ შეკვეთები მესინჯერ აპლიკაციებიდან (Viber, WhatsApp, Telegram). სერვისი მოიცავს შეკვეთების ამოღებას, კლიენტების მართვას, ანალიტიკას და მონაცემების ექსპორტის ფუნქციებს.",
      },
      accountRegistration: {
        title: "3. ანგარიშის რეგისტრაცია",
        items: [
          "თქვენ უნდა იყოთ მინიმუმ 18 წლის OrderFlow-ის გამოსაყენებლად",
          "თქვენ უნდა მიაწოდოთ ზუსტი და სრული რეგისტრაციის ინფორმაცია",
          "თქვენ პასუხისმგებელი ხართ თქვენი ანგარიშის უსაფრთხოების შენარჩუნებაზე",
          "ერთი ანგარიში ერთ ბიზნეს სუბიექტზე დაშვებულია",
          "ჩვენ ვიტოვებთ უფლებას დავამტკიცოთ ან უარვყოთ რეგისტრაციები",
        ],
      },
      subscriptionAndPayment: {
        title: "4. გამოწერა და გადახდა",
        plansAndPricing: {
          title: "პაკეტები და ფასები (ქართულ ლარში - ₾)",
          items: [
            "სტარტერი: ₾50/თვე - 100-მდე შეკვეთა, 1 მომხმარებელი",
            "პროფესიონალი: ₾149/თვე - 500-მდე შეკვეთა, 3 მომხმარებელი",
            "ბიზნესი: ₾399/თვე - შეუზღუდავი შეკვეთები, 10 მომხმარებელი",
            "საწარმო: ინდივიდუალური ფასი",
          ],
        },
        paymentTerms: {
          title: "გადახდის პირობები",
          items: [
            "14-დღიანი უფასო საცდელი (საკრედიტო ბარათის გარეშე)",
            "გადახდა წინასწარ ყოველთვიურად ან წლიურად",
            "წლიური პაკეტები იღებს 20% ფასდაკლებას",
            "გადახდები არ იბრუნება, გარდა კანონით მოთხოვნილისა",
          ],
        },
      },
      acceptableUse: {
        title: "5. მისაღები გამოყენება",
        youMay: {
          title: "თქვენ შეგიძლიათ:",
          items: [
            "გამოიყენოთ OrderFlow ლეგიტიმური ბიზნეს მიზნებისთვის",
            "დაამუშაოთ ნამდვილი მომხმარებლების შეკვეთები",
            "გენერირება გაუკეთოთ ბიზნეს ანალიზს",
            "ექსპორტი გაუკეთოთ თქვენს მონაცემებს",
          ],
        },
        youMayNot: {
          title: "თქვენ არ შეგიძლიათ:",
          items: [
            "გამოიყენოთ OrderFlow უკანონო საქმიანობისთვის",
            "დაამუშაოთ თაღლითური ტრანზაქციები",
            "სცადოთ ჩვენი ტექნოლოგიის რევერს-ინჟინერინგი",
            "გადაყიდოთ ან სუბლიცენზირება გაუკეთოთ სერვისს",
            "დაარღვიოთ რაიმე მოქმედი კანონი ან რეგულაციები",
            "შეინახოთ აკრძალული ან მავნე კონტენტი",
          ],
        },
      },
      intellectualProperty: {
        title: "6. ინტელექტუალური საკუთრება",
        items: [
          "თქვენ ინარჩუნებთ საკუთრებას თქვენს ბიზნეს მონაცემებზე",
          "OrderFlow ინარჩუნებს ყველა უფლებას ჩვენს პროგრამულ უზრუნველყოფაზე, AI მოდელებსა და ბრენდინგზე",
          "თქვენ გვაძლევთ ლიცენზიას დავამუშაოთ თქვენი მონაცემები სერვისის უზრუნველსაყოფად",
          "ნებისმიერი უკუკავშირი, რომელსაც თქვენ გვაწვდით, ხდება ჩვენი საკუთრება",
        ],
      },
      dataProcessing: {
        title: "7. მონაცემთა დამუშავება",
        items: [
          "ჩვენ ვამუშავებთ მონაცემებს ჩვენი კონფიდენციალურობის პოლიტიკის მიხედვით",
          "AI ამოღება დაახლოებით 95% ზუსტია - რეკომენდებულია ადამიანის მიერ შემოწმება",
          "თქვენ პასუხისმგებელი ხართ საბოლოო მონაცემების სიზუსტეზე",
          "ჩვენ ვიყენებთ Google Gemini AI დამუშავებისთვის",
          "მონაცემები შეიძლება დამუშავდეს საერთაშორისოდ შესაბამისი უსაფრთხოების ღონისძიებებით",
        ],
      },
      serviceAvailability: {
        title: "8. სერვისის ხელმისაწვდომობა",
        items: [
          "ჩვენ ვისწრაფვით 99.9% მუშაობისკენ (გარდა ტექნიკური მომსახურებისა)",
          "მხარდაჭერა ხელმისაწვდომია ორშაბათ-პარასკევს, 9:00-18:00 თბილისის დროით",
          "ჩვენ შეიძლება შევცვალოთ ან შევაჩეროთ ფუნქციები შეტყობინებით",
          "დაგეგმილი ტექნიკური მომსახურება წინასწარ გამოცხადდება",
        ],
      },
      limitationOfLiability: {
        title: "9. პასუხისმგებლობის შეზღუდვა",
        items: [
          "ჩვენი პასუხისმგებლობა შეზღუდულია თანხით, რომელიც გადახდილია 12 თვის განმავლობაში ნებისმიერი პრეტენზიის წინ",
          "ჩვენ არ ვართ პასუხისმგებელი არაპირდაპირ, შემთხვევით ან თანმდევ ზიანზე",
          "ჩვენ არ ვართ პასუხისმგებელი დაკარგულ მოგებაზე ან მონაცემთა დაკარგვაზე",
          "ეს შეზღუდვები არ ვრცელდება უხეში დაუდევრობაზე ან განზრახ არასწორ ქმედებაზე",
        ],
      },
      warranties: {
        title: "10. გარანტიები და უარყოფები",
        content:
          'სერვისი მოწოდებულია "როგორც არის" ყოველგვარი გარანტიის გარეშე, როგორც გამოხატული, ისე ნაგულისხმევი. ჩვენ არ ვგარანტირებთ, რომ სერვისი იქნება უწყვეტი, შეცდომების გარეშე, ან სრულად უსაფრთხო.',
      },
      indemnification: {
        title: "11. ანაზღაურება",
        intro: "თქვენ ეთანხმებით ანაზღაუროთ და დაიცვათ OrderFlow ნებისმიერი პრეტენზიისგან, რომელიც წარმოიშვება:",
        items: [
          "თქვენი სერვისის გამოყენებიდან",
          "თქვენი ამ პირობების დარღვევიდან",
          "სხვა მხარის უფლებების დარღვევიდან",
          "თქვენი კონტენტიდან ან მონაცემებიდან",
        ],
      },
      termination: {
        title: "12. შეწყვეტა",
        items: [
          "თქვენ შეგიძლიათ გააუქმოთ თქვენი გამოწერა ნებისმიერ დროს",
          "ჩვენ შეიძლება შევაჩეროთ ანგარიშები, რომლებიც არღვევენ ამ პირობებს",
          "შეწყვეტისას, თქვენ გაქვთ 30 დღე თქვენი მონაცემების ექსპორტისთვის",
          "30 დღის შემდეგ, თქვენი მონაცემები სამუდამოდ წაიშლება",
        ],
      },
      changesToTerms: {
        title: "13. ცვლილებები პირობებში",
        intro: "ჩვენ შეიძლება შევცვალოთ ეს პირობები ნებისმიერ დროს. მნიშვნელოვანი ცვლილებები მოიცავს:",
        items: [
          "30-დღიან წინასწარ შეტყობინებას ელ.ფოსტით",
          "შესაძლებლობას ექსპორტი გაუკეთოთ მონაცემებს ცვლილებების ძალაში შესვლამდე",
          "გაგრძელებული გამოყენება ნიშნავს ახალი პირობების მიღებას",
        ],
      },
      governingLaw: {
        title: "14. მარეგულირებელი კანონი",
        content:
          "ეს პირობები რეგულირდება საქართველოს კანონმდებლობით. ნებისმიერი დავა გადაწყდება თბილისის, საქართველოს სასამართლოებში.",
      },
      privacyAndDataProtection: {
        title: "15. კონფიდენციალურობა და მონაცემთა დაცვა",
        content:
          "OrderFlow-ის გამოყენებით თქვენ ეთანხმებით ჩვენს კონფიდენციალურობის პოლიტიკას. ჩვენ ვამუშავებთ პერსონალურ მონაცემებს GDPR-ისა და საქართველოს პერსონალურ მონაცემთა დაცვის კანონის შესაბამისად.",
      },
      exportControl: {
        title: "16. ექსპორტის კონტროლი",
        content: "თქვენ ეთანხმებით დაიცვათ ყველა მოქმედი ექსპორტისა და იმპორტის კანონი და რეგულაცია.",
      },
      entireAgreement: {
        title: "17. სრული შეთანხმება",
        content:
          "ეს პირობები და ჩვენი კონფიდენციალურობის პოლიტიკა წარმოადგენს სრულ შეთანხმებას თქვენსა და OrderFlow-ს შორის.",
      },
      severability: {
        title: "18. გამიჯვნა",
        content:
          "თუ ამ პირობების რომელიმე დებულება ნაპოვნია შეუსრულებლად, დანარჩენი დებულებები განაგრძობენ სრულ ძალაში ყოფნას.",
      },
      contact: {
        title: "19. საკონტაქტო ინფორმაცია",
        generalSupport: "ზოგადი მხარდაჭერა:",
        email: "ელ.ფოსტა: support@orderflow.ge",
        phone: "ტელეფონი: +995 XXX XXX XXX",
        legalInquiries: "სამართლებრივი შეკითხვები:",
        legalEmail: "ელ.ფოსტა: legal@orderflow.ge",
        address: "მისამართი:",
        addressLine1: "[თქვენი კომპანიის სახელი]",
        addressLine2: "[ქუჩის მისამართი]",
        addressLine3: "[საფოსტო კოდი] თბილისი, საქართველო",
      },
      acknowledgment:
        "OrderFlow-ის გამოყენებით თქვენ ადასტურებთ, რომ წაიკითხეთ, გაიგეთ და ეთანხმებით ამ მომსახურების პირობებს.",
    },
  },
  cookieConsent: {
    message: "ვიყენებთ ქუქიებს სერვისების მუშაობისთვის. გაგრძელებით ეთანხმებით მათ გამოყენებას.",
    acceptAll: "მიღება",
    rejectNonEssential: "უარყოფა",
    learnMore: "მეტი",
    essentialOnly: "აუცილებელი",
  },
  resetPassword: {
    title: "დააყენეთ ახალი პაროლი",
    description: "გთხოვთ აირჩიოთ უსაფრთხო პაროლი თქვენი ანგარიშისთვის.",
    newPassword: "ახალი პაროლი",
    confirmPassword: "დაადასტურეთ პაროლი",
    updateButton: "პაროლის განახლება",
    updating: "მიმდინარეობს განახლება...",
    successMessage: "პაროლი წარმატებით განახლდა!",
    errorPasswordsMismatch: "პაროლები არ ემთხვევა",
    errorPasswordTooShort: "პაროლი უნდა იყოს მინიმუმ 8 სიმბოლო და შეიცავდეს დიდ ასოს, პატარა ასოს და ციფრს",
    errorGeneric: "პაროლის განახლება ვერ მოხერხდა. გთხოვთ სცადოთ ხელახლა.",
    cancelled: "გაუქმებულია",
    cancelledDescription: "პაროლის აღდგენა გაუქმდა. თქვენ გამოხვედით სისტემიდან.",
  },
  forcePasswordChange: {
    title: "საჭიროა პაროლის შეცვლა",
    description: "უსაფრთხოების მიზნით, გაგრძელებამდე უნდა დააყენოთ ახალი პაროლი.",
    newPassword: "ახალი პაროლი",
    confirmPassword: "დაადასტურეთ პაროლი",
    updateButton: "პაროლის განახლება",
    updating: "მიმდინარეობს განახლება...",
    successMessage: "პაროლი წარმატებით განახლდა!",
    errorPasswordsMismatch: "პაროლები არ ემთხვევა",
    errorPasswordTooShort: "პაროლი უნდა იყოს მინიმუმ 8 სიმბოლო და შეიცავდეს დიდ ასოს, პატარა ასოს და ციფრს",
    errorGeneric: "პაროლის განახლება ვერ მოხერხდა. გთხოვთ სცადოთ ხელახლა.",
  },
  admin: {
    layout: {
      title: "ადმინისტრატორის პანელი",
      users: "მომხმარებლები",
      applications: "განაცხადები",
      statistics: "სტატისტიკა",
      history: "ისტორია",
      customers: "მომხმარებლები",
      settings: "პარამეტრები",
      menu: "მენიუ",
      signOut: "გასვლა",
      viewOrders: "შეკვეთების ნახვა",
    },
    customerActivity: {
      title: "მომხმარებლების აქტივობა",
      description: "აგრეგირებული ბიზნეს მეტრიკები აქტიური მომხმარებლებისთვის (GDPR-დაცული, პირადი მონაცემების გარეშე)",
      search: "ძიება სახელით ან კომპანიით...",
      noData: "აქტიური მომხმარებლები ვერ მოიძებნა",
      metrics: {
        activeCustomers: "აქტიური მომხმარებლები",
        totalRevenue: "მთლიანი შემოსავალი",
        totalOrders: "მთლიანი შეკვეთები",
      },
      sort: {
        revenue: "შემოსავალი",
        orders: "შეკვეთები",
        recent: "ბოლო",
        lastActivity: "ბოლო აქტივობა",
      },
      table: {
        business: "ბიზნესი",
        revenue: "შემოსავალი",
        orders: "შეკვეთები",
        recent30: "ბოლო 30 დღე",
        successRate: "წარმატების %",
        deliveryLinks: "მიტანის ლინკები",
        lastOrder: "ბოლო შეკვეთა",
        status: "სტატუსი",
      },
      status: {
        active: "აქტიური",
        trial: "საცდელი",
        expired: "ვადაგასული",
      },
      hide: "სიიდან დამალვა",
      unhide: "სიაში ჩვენება",
      showHidden: "დამალულების ჩვენება",
      hideHidden: "დამალულების დაფარვა",
    },
    statistics: {
      title: "სტატისტიკა და ანალიტიკა",
      description: "მომხმარებლების ჩართულობისა და დემოს შედეგების მონიტორინგი",
      userEngagement: {
        title: "მომხმარებლების ჩართულობის მიმოხილვა",
        totalUsers: "სულ მომხმარებლები",
        neverLoggedIn: "არასოდეს შესულა",
        noOrders: "შეკვეთები არ აქვს",
        activeRecently: "აქტიური (7 დღე)",
        atRisk: "რისკის ქვეშ (14+ დღე)",
        table: {
          user: "მომხმარებელი",
          lastLogin: "ბოლო შესვლა",
          orders: "შეკვეთები",
          status: "სტატუსი",
          never: "არასოდეს",
          noUsers: "მომხმარებლები ვერ მოიძებნა",
          statusActive: "აქტიური",
          statusAtRisk: "რისკის ქვეშ",
          statusNever: "არ შესულა",
          statusNoOrders: "შეკვეთები არ აქვს",
        },
      },
    },
    demoStats: {
      title: "დემო ვიჯეტის სტატისტიკა",
      totalDemos: "სულ დემოები",
      successRate: "წარმატების მაჩვენებელი",
      avgTime: "საშ. დრო",
      today: "დღეს",
      conversions: "კონვერსიები",
    },
    users: {
      title: "მომხმარებლების მართვა",
      description: "მართეთ დამტკიცებული მომხმარებლები და მათი როლები",
      search: "ძიება სახელით, ელფოსტით ან კომპანიით...",
      refresh: "განახლება",
      inviteUser: "მომხმარებლის მოწვევა",
      recentInvitations: "ბოლო მოწვევები",
      noInvitations: "მოწვევები ჯერ არ გაგზავნილა",
      noInvitationsDesc: "ახალი მოწვევები აქ გამოჩნდება",
      loadingUsers: "მომხმარებლები იტვირთება...",
      noUsersMatch: "თქვენს ძიებას არ შეესაბამება მომხმარებლები",
      filters: {
        all: "ყველა",
        active: "აქტიური",
        deactivated: "დეაქტივირებული",
      },
      stats: {
        total: "სულ მომხმარებლები",
        active: "აქტიური მომხმარებლები",
        deactivated: "დეაქტივირებული",
        admins: "ადმინისტრატორები",
      },
      table: {
        name: "სახელი",
        email: "ელფოსტა",
        company: "კომპანია",
        businessType: "ბიზნესის ტიპი",
        role: "როლი",
        status: "სტატუსი",
        invitationStatus: "მოწვევა",
        joined: "შეუერთდა",
        actions: "მოქმედებები",
        noUsers: "მომხმარებლები ვერ მოიძებნა",
        noRole: "როლი არ არის",
        noName: "სახელი არ არის",
      },
      status: {
        active: "აქტიური",
        deactivated: "დეაქტივირებული",
      },
      invitationStatus: {
        accepted: "მიღებულია",
        pending: "მოლოდინში",
        not_invited: "არ არის მოწვეული",
      },
      invitationDetails: {
        title: "მოწვევის დეტალები",
        status: "მოწვევის სტატუსი",
        invitedDate: "მოწვევის თარიღი",
        acceptedDescription: "მომხმარებელმა მიიღო მოწვევა და შევიდა სისტემაში",
        pendingDescription: "მოწვევა გაგზავნილია, ელოდება მომხმარებლის მოქმედებას",
        notInvitedDescription: "მომხმარებელი დარეგისტრირდა პირდაპირ მოწვევის გარეშე",
      },
      businessTypes: {
        retail: "საცალო ვაჭრობა",
        restaurant: "რესტორანი/კაფე",
        wholesale: "საბითუმო ვაჭრობა",
        ecommerce: "ელექტრონული კომერცია",
        service: "სერვისი",
        other: "სხვა",
      },
      actions: {
        manageFeatures: "ფუნქციების მართვა",
        resendInvite: "მისასალმებელი ელფოსტის ხელახლა გაგზავნა",
        resendApproval: "დამტკიცების ელფოსტის ხელახლა გაგზავნა",
        changeRole: "როლის შეცვლა",
        deactivate: "მომხმარებლის დეაქტივაცია",
        reactivate: "მომხმარებლის აქტივაცია",
        delete: "მომხმარებლის წაშლა",
      },
    },
    features: {
      title: "ფუნქციების მართვა",
      externalOrder: {
        title: "გარე შეკვეთების მიღება",
        description:
          "მიეცით ამ მომხმარებელს საშუალება მიიღოს შეკვეთები საჯარო ბმულის მეშვეობით. კლიენტებს შეუძლიათ შეკვეთების გაკეთება ანგარიშის გარეშე.",
      },
      customersModule: {
        title: "მომხმარებლების მოდული",
        description: "ჩართეთ მომხმარებლების თვალყურის დევნება შეკვეთების ისტორიით, შემოსავლის სტატისტიკით და მიტანის მისამართებით.",
      },
      enabledSuccess: "ფუნქციის პარამეტრები შენახულია",
      disabledSuccess: "ფუნქცია წარმატებით გამორთულია",
      saveFailed: "ფუნქციის პარამეტრები ვერ შეინახა",
    },
    applications: {
      title: "წვდომის განაცხადები",
      description: "განიხილეთ და დაამტკიცეთ ახალი მომხმარებლების რეგისტრაციები",
      search: "განაცხადების ძიება...",
      refresh: "განახლება",
      filters: {
        all: "ყველა",
        pending: "განხილვაში",
        approved: "დამტკიცებული",
        rejected: "უარყოფილი",
      },
      table: {
        applicant: "განმცხადებელი",
        email: "ელფოსტა",
        company: "კომპანია",
        businessType: "ბიზნესის ტიპი",
        status: "სტატუსი",
        date: "გაიგზავნა",
        actions: "მოქმედებები",
        noApplications: "განაცხადები ვერ მოიძებნა",
      },
      status: {
        pending: "განხილვაში",
        approved: "დამტკიცებული",
        rejected: "უარყოფილი",
      },
      actions: {
        review: "განხილვა",
      },
    },
    reviewModal: {
      title: "განაცხადის განხილვა",
      approve: "განაცხადის დამტკიცება",
      reject: "განაცხადის უარყოფა",
      approving: "მტკიცდება...",
      rejecting: "უარყოფა...",
      cancel: "გაუქმება",
      rejectionReason: "უარყოფის მიზეზი",
      rejectionPlaceholder: "გთხოვთ მიუთითოთ უარყოფის მიზეზი...",
      rejectionRequired: "უარყოფის მიზეზის მითითება აუცილებელია",
      applicantInfo: "განმცხადებლის ინფორმაცია",
      name: "სრული სახელი",
      email: "ელფოსტა",
      phone: "ტელეფონი",
      company: "კომპანიის სახელი",
      businessType: "ბიზნესის ტიპი",
      referral: "როგორ გაიგეთ ჩვენ შესახებ?",
      message: "დამატებითი შეტყობინება",
      status: "მიმდინარე სტატუსი",
      appliedDate: "გაგზავნის თარიღი",
      businessTypes: {
        retail: "საცალო მაღაზია",
        restaurant: "რესტორანი/კაფე",
        wholesale: "საბითუმო ვაჭრობა",
        ecommerce: "ელექტრონული კომერცია",
        service: "სერვისის ბიზნესი",
        other: "სხვა",
      },
      statuses: {
        pending: "განხილვაში",
        approved: "დამტკიცებული",
        rejected: "უარყოფილი",
      },
    },
    deactivateDialog: {
      title: "მომხმარებლის ანგარიშის დეაქტივაცია",
      description:
        "დარწმუნებული ხართ, რომ გსურთ ამ მომხმარებლის ანგარიშის დეაქტივაცია? მათ აღარ შეეძლებათ სისტემაში შესვლა.",
      reactivateNote: "საჭიროების შემთხვევაში შეგიძლიათ ხელახლა გაააქტიუროთ ეს ანგარიში.",
      cancel: "გაუქმება",
      confirm: "მომხმარებლის დეაქტივაცია",
      confirming: "დეაქტივაცია...",
    },
    deleteDialog: {
      title: "მომხმარებლის ანგარიშის წაშლა",
      description:
        "ეს მოქმედება სამუდამოდ წაშლის მომხმარებლის ანგარიშსა და ყველა დაკავშირებულ მონაცემს. ეს მოქმედება შეუქცევადია.",
      confirmInstruction: "დაბეჭდეთ DELETE დასადასტურებლად:",
      confirmPlaceholder: "დაბეჭდეთ DELETE აქ",
      cancel: "გაუქმება",
      confirm: "სამუდამოდ წაშლა",
      confirming: "იშლება...",
    },
    inviteDialog: {
      title: "ახალი მომხმარებლის მოწვევა",
      description: "გაგზავნეთ მოწვევის ელფოსტა თქვენს ორგანიზაციაში ახალი მომხმარებლის დასამატებლად.",
      email: "ელფოსტის მისამართი",
      emailPlaceholder: "user@example.com",
      fullName: "სრული სახელი",
      fullNamePlaceholder: "გიორგი მაისურაძე",
      company: "კომპანიის სახელი",
      companyPlaceholder: "არასავალდებულო",
      personalMessage: "პირადი შეტყობინება",
      messagePlaceholder: "დაამატეთ მისასალმებელი შეტყობინება (არასავალდებულო)",
      role: "როლის მინიჭება",
      language: "მოწვევის ენა",
      submit: "მოწვევის გაგზავნა",
      cancel: "გაუქმება",
      sending: "იგზავნება...",
    },
    roles: {
      user: "მომხმარებელი",
      userDescription: "ძირითადი წვდომა შეკვეთებსა და ფუნქციებზე",
      manager: "მენეჯერი",
      managerDescription: "შეუძლია შეკვეთების მართვა და ანგარიშების ნახვა",
      admin: "ადმინისტრატორი",
      adminDescription: "სრული წვდომა ყველა ფუნქციასა და პარამეტრზე",
    },
    toasts: {
      inviteSuccess: "მოწვევა წარმატებით გაიგზავნა!",
      inviteSuccessDesc: "მომხმარებელი მიიღებს ელფოსტას ანგარიშის დაყენების ინსტრუქციებით.",
      inviteError: "მოწვევა ვერ გაიგზავნა",
      inviteErrorDesc: "გთხოვთ, სცადოთ ხელახლა ან დაუკავშირდეთ მხარდაჭერას.",
      resendSuccess: "მოწვევა ხელახლა გაიგზავნა!",
      resendSuccessDesc: "ახალი მოწვევის ელფოსტა გაიგზავნა.",
      resendError: "ხელახლა გაგზავნა ვერ მოხდა",
      roleChangeSuccess: "როლი განახლდა!",
      roleChangeSuccessDesc: "მომხმარებლის როლი წარმატებით განახლდა.",
      roleChangeError: "როლი ვერ განახლდა",
      deactivateSuccess: "მომხმარებელი დეაქტივირებულია",
      deactivateSuccessDesc: "მომხმარებლის ანგარიში დეაქტივირებულია.",
      deactivateError: "მომხმარებელი ვერ დეაქტივირდა",
      reactivateSuccess: "მომხმარებელი აქტივირებულია",
      reactivateSuccessDesc: "მომხმარებლის ანგარიში აქტივირებულია.",
      reactivateError: "მომხმარებელი ვერ აქტივირდა",
      deleteSuccess: "მომხმარებელი წაშლილია",
      deleteSuccessDesc: "მომხმარებლის ანგარიში სამუდამოდ წაშლილია.",
      deleteError: "მომხმარებელი ვერ წაიშალა",
      approveSuccess: "განაცხადი დამტკიცებულია! ✅",
      approveSuccessDesc: "დამტკიცდა. მათ მიიღებენ მისასალმებელ ელფოსტას შესვლის ინსტრუქციებით.",
      approveError: "დამტკიცება ვერ მოხდა",
      rejectSuccess: "განაცხადი უარყოფილია",
      rejectSuccessDesc: "განმცხადებელი შეტყობინებულია უარყოფის შესახებ.",
      rejectError: "უარყოფა ვერ მოხდა",
      loadError: "რაღაც არ მუშაობს",
      loadErrorDesc: "მონაცემები ვერ ჩაიტვირთა",
      loadUserHistoryError: "ისტორია ვერ ჩაიტვირთა",
      genericError: "რაღაც არ მუშაობს. სცადეთ ხელახლა.",
      rejectionReasonRequired: "უარყოფის მიზეზი აუცილებელია",
      rejectionReasonRequiredDesc: "გთხოვთ მიუთითოთ განაცხადის უარყოფის მიზეზი.",
    },
    userHistory: {
      title: "მომხმარებლების ისტორია",
      description: "მომხმარებლების სასიცოცხლო ციკლისა და ადმინისტრაციული მოქმედებების სრული ჟურნალი",
      filters: "ფილტრები",
      filtersDescription: "მოძებნეთ და გაფილტრეთ ისტორიის ჩანაწერები",
      searchPlaceholder: "ძიება ელფოსტით, სახელით ან კომპანიით...",
      eventType: "მოვლენის ტიპი",
      refresh: "განახლება",
      allEvents: "ყველა მოვლენა",
      noEventsFound: "ისტორიის ჩანაწერები ვერ მოიძებნა",
      pageOf: "გვერდი {{current}} / {{total}}",
      performedBySystem: "სისტემა",
      performedByLabel: "შესრ.:",
      table: {
        timestamp: "თარიღი",
        user: "მომხმარებელი",
        event: "მოვლენა",
        details: "დეტალები",
        performedBy: "შესრულებული",
      },
      events: {
        created: "შექმნილი",
        invited: "მოწვეული",
        approved: "დამტკიცებული",
        rejected: "უარყოფილი",
        deleted: "წაშლილი",
        deactivated: "დეაქტივირებული",
        reactivated: "აქტივირებული",
        login: "შესვლა",
        password_changed: "პაროლი შეიცვალა",
      },
    },
  },
  delivery: {
    mobileCard: {
      title: "მიწოდების სესიები",
      activeDesc: "{count} აქტიური სესია",
      noActiveDesc: "შექმენით ბმული კურიერისთვის",
      createNew: "ახალი სესიის შექმნა",
    },
    completed: "დასრულებული",
    shareTitle: "მიწოდების ბმული",
    shareText: "მიწოდების თვალყურის დევნება:",
    modeToggle: {
      orders: "შეკვეთები",
      delivery: "მიწოდება",
    },
    kpi: {
      sectionTitle: "დღევანდელი მიწოდების სტატუსი",
      ready: "მზადაა",
      outForDelivery: "მიტანაში",
      failed: "ვერ მოხერხდა",
      deliveredToday: "მიტანილი დღეს",
    },
    statuses: {
      outForDelivery: "მიტანის პროცესში",
      delivered: "მიტანილია",
      deliveryFailed: "მიტანა ვერ მოხერხდა",
    },
    actions: {
      markDelivered: "მიტანილია",
      markOutForDelivery: "მიტანაში",
      markFailed: "ვერ მოხერხდა",
      retryDelivery: "ხელახლა ცდა",
      reportProblem: "პრობლემა?",
      call: "დარეკვა",
      navigate: "ნავიგაცია",
      failed: "ვერ მოხერხდა",
    },
    callCustomer: "დარეკე მომხმარებელს",
    groups: {
      other: "სხვა",
    },
    warnings: {
      addressRequired: "მისამართი აუცილებელია",
      addressRequiredDescription: "გთხოვთ დაამატოთ მისამართი ამ შეკვეთის მისატანად გაგზავნამდე",
      noAddress: "მიტანის მისამართი არ არის მითითებული - დაამატეთ მისამართი გაგზავნამდე",
    },
    addressRequired: "მისამართი მითითება აუცილებელია მიტანისთვის",
    nextUp: "შემდეგი",
    readySince: "მზადაა",
    progress: "{delivered} {total}-დან მიტანილია",
    problemReported: "პრობლემა დაფიქსირდა - დაგიკავშირდებით",
    messages: {
      markedOutForDelivery: "შეკვეთა მონიშნულია როგორც მიტანაში",
      markedDelivered: "შეკვეთა მონიშნულია როგორც მიტანილი ✓",
      deliveryUndone: "მიტანის სტატუსი გაუქმდა",
      markedFailed: "შეკვეთა მონიშნულია როგორც მიტანა ვერ მოხერხდა",
      failedUndone: "წარუმატებელი სტატუსი გაუქმდა",
      retryDelivery: "შეკვეთა ხელახლა გაგზავნილია მიტანაში",
      markOutForDeliveryError: "შეკვეთის მიტანაში მონიშვნა ვერ მოხერხდა",
      markDeliveredError: "შეკვეთის მიტანილად მონიშვნა ვერ მოხერხდა",
      markFailedError: "შეკვეთის წარუმატებლად მონიშვნა ვერ მოხერხდა",
      updateStatusError: "მიტანის სტატუსის განახლება ვერ მოხერხდა",
    },
    failureReasons: {
      customerNotHome: "კლიენტი არ იყო სახლში",
      wrongAddress: "არასწორი მისამართი",
      customerRefused: "კლიენტმა უარი თქვა",
      cannotAccess: "ლოკაციაზე წვდომა ვერ მოხერხდა",
      customerUnreachable: "კლიენტთან დაკავშირება ვერ მოხერხდა",
    },
    failureModal: {
      title: "მიტანა ვერ მოხერხდა",
      description: "გთხოვთ აირჩიოთ მიტანის წარუმატებლობის მიზეზი",
      notifyHint: "ეს დაუყოვნებლივ აცნობებს მენეჯერს",
      selectReason: "მიზეზის არჩევა",
      additionalNotes: "დამატებითი შენიშვნა (არჩევითი)",
      notesPlaceholder: "დამატებითი დეტალები...",
      confirm: "დადასტურება",
      cancel: "გაუქმება",
    },
    empty: {
      title: "ყველაფერი მზადაა!",
      description: "ამჟამად მიტანისთვის მომლოდინე შეკვეთები არ არის.",
    },
    deliveredToday: {
      title: "დღეს მიტანილი",
      deliveredAt: "მიტანილია",
      noDeliveries: "დღეს მიტანა ჯერ არ შესრულებულა",
    },
    activeLinks: "აქტიური მიტანები",
    // Link generation
    generateLink: "მიტანის დაწყება",
    generateLinkShort: "შექმენით ბმული კურიერისთვის",
    generateLinkDescription: "შექმენით ბმული კურიერისთვის გასაზიარებლად",
    linkDuration: "ბმულის ხანგრძლივობა",
    includeOrders: "შეკვეთების შერჩევა",
    readyOrders: "მზა შეკვეთები",
    readyOrdersDesc: "შეკვეთები რომლებიც მზადაა გატანისთვის",
    outForDeliveryOrders: "მიტანაში მყოფი შეკვეთები",
    outForDeliveryOrdersDesc: "უკვე გაგზავნილი შეკვეთები",
    generate: "მიტანის შექმნა",
    endOfDay: "დღის ბოლომდე",
    unlimited: "შეუზღუდავი",
    unlimitedDesc: "ვადის გარეშე - ბმული აქტიურია დახურვამდე",
    noOrdersWarning: "მიტანისთვის მზა შეკვეთები არ არის. ჯერ მონიშნეთ შეკვეთები როგორც 'მზადაა'.",
    allOrdersAssigned: "ყველა მზა შეკვეთა უკვე მინიჭებულია აქტიურ სესიებზე.",
    selectOrdersHint: "აირჩიეთ შეკვეთები მიტანაში ჩასართავად",
    linkGenerated: "მიტანა შეიქმნა",
    ordersIncluded: "შეკვეთა შეტანილია",
    linkReady: "მიტანის ბმული მზადაა გასაზიარებლად",
    deliveryLink: "მიტანის ბმული",
    linkCopied: "ბმული დაკოპირდა",
    expiresIn: "ვადა",
    hours: "საათი",
    noOrdersForLink: "შერჩეული კრიტერიუმებით შეკვეთები ვერ მოიძებნა",
    // Active link banner
    link: {
      active: "აქტიური მიტანა",
      expired: "ვადა გასულია",
      copy: "კოპირება",
      revoke: "მიტანის დახურვა",
      revokeTitle: "დაიხუროს მიტანა?",
      revokeWarning:
        "ეს დაუყოვნებლივ დახურავს მიტანას. კურიერი ამ ბმულით ვეღარ შეძლებს შეკვეთებზე წვდომას ან მათ მიტანილად მონიშვნას.",
      revoked: "მიტანა დაიხურა",
      revokedDescription: "მიტანა დეაქტივირდა",
      revokeError: "მიტანის დახურვა ვერ მოხერხდა",
      openExternal: "ბმულის გახსნა ახალ ჩანართში",
    },
    // Sharing
    share: {
      button: "გაგზავნა",
      copyLink: "ბმულის კოპირება",
      more: "სხვა...",
      title: "მიტანის ბმული",
      messagePrefix: "მიტანის ბმული",
      orders: "შეკვეთა",
    },
    // Label
    labelInput: "კურიერი / მარშრუტი (არასავალდებულო)",
    labelPlaceholder: "მაგ., გიორგი, დილის მარშრუტი",
    // Order preview
    preview: {
      title: "შეკვეთების გადახედვა",
      noOrders: "შერჩეული კრიტერიუმებით შეკვეთები ვერ მოიძებნა",
      selectAll: "ყველას მონიშვნა",
      deselectAll: "მონიშვნის მოხსნა",
      selected: "მონიშნული",
    },
    deactivate: {
      title: "მიტანის დახურვა",
      description: "დარწმუნებული ხართ, რომ გსურთ ამ მიტანის დახურვა? კურიერი ვეღარ შეძლებს შეკვეთებზე წვდომას.",
      cancel: "გაუქმება",
      confirm: "მიტანის დახურვა",
      confirming: "იხურება...",
      message: "მიუტანელი შეკვეთა რჩება",
      reassign: "შეკვეთების სხვა მიტანაზე გადატანა",
      recommended: "რეკომენდებული",
      reassignDesc: "გადაიტანეთ მიუტანელი შეკვეთები სხვა აქტიურ მიტანაზე დახურვამდე",
      selectSession: "აირჩიეთ მიტანა",
      selectSessionRequired: "გთხოვთ აირჩიოთ სამიზნე მიტანა",
      noOtherSessions: "სხვა აქტიური მიტანები არ არის",
      keepActive: "მიტანის აქტიურად დატოვება",
      keepActiveDesc: "ჯერ არ დახუროთ მიტანა, გააგრძელეთ მუშაობა",
      advancedOptions: "დამატებითი ოპციები",
      forceClose: "იძულებით დახურვა",
      forceCloseDesc: "დახურეთ მიტანა დაუყოვნებლივ. მიუტანელი შეკვეთები გახდება დაუნიშნავი.",
      confirmReassign: "გადატანა და დახურვა",
      reassignSuccess: "მიტანა დაიხურა",
      ordersReassigned: "შეკვეთა გადავიდა ახალ მიტანაზე",
      forceCloseSuccess: "მიტანა იძულებით დაიხურა",
      forceCloseSuccessDesc: "მიუტანელი შეკვეთები გახდა დაუნიშნავი",
      thisSession: "ეს მიტანა",
      forceCloseWarningTitle: "მიტანის იძულებით დახურვა?",
      forceCloseWarning: "შეკვეთა გახდება დაუნიშნავი და საჭირო იქნება ხელახალი გაგზავნა",
      confirmForceClose: "იძულებით დახურვა",
    },
    // KPI bar
    outForDelivery: "მიტანაში",
    activeSessions: "აქტიური მიტანები",
    // Session management
    remaining: "დარჩენილია",
    active: "აქტიური",
    defaultLabel: "მიტანა",
    openLink: "ლინკის გახსნა",
    pending: "მოლოდინში",
    statusDropdown: {
      inTransit: "გზაში",
    },
    endSession: "მიტანის დახურვა",
    noActiveSessions: "აქტიური მიტანები არ არის",
    noActiveSessionsDesc: "შექმენით მიტანა კურიერებისთვის შეკვეთების გასაგზავნად",
    createSession: "მიტანის დაწყება",
    // Card labels
    total: "სულ",
    delivered: "მიტანილი",
    progressLabel: "პროგრესი",
    // Loading Manifest
    manifest: {
      title: "დატვირთვის მანიფესტი",
      pickingSummary: "აღების სია",
      pickingSummaryDesc: "ჯამური პროდუქტები საწყობიდან",
      loadingChecklist: "ჩატვირთვის ჩეკლისტი",
      loadingChecklistDesc: "გადაამოწმეთ თითოეული შეკვეთა",
      ordersToLoad: "შეკვეთა ჩასატვირთად",
      allLoaded: "ყველა შეკვეთა ჩატვირთულია!",
      viewManifest: "მანიფესტის ნახვა",
      hideManifest: "მანიფესტის დამალვა",
      orderLoaded: "ჩატვირთული",
      noAddress: "მისამართი არ არის",
      noItems: "პროდუქტები არ არის",
      loadingOrders: "იტვირთება...",
      noOrdersInSession: "ამ სესიაში შეკვეთები არ არის",
      totalProducts: "სულ პროდუქტები",
      checkedOff: "მონიშნული",
    },
    // History section
    history: {
      title: "დახურული მარშრუტები",
      empty: "დახურული მარშრუტები ჯერ არ არის",
      completed: "დასრულებული",
      ended: "დახურული",
      expired: "ვადაგასული",
      showHistory: "ისტორიის ჩვენება",
      hideHistory: "ისტორიის დამალვა",
      sessions: "მარშრუტი",
      ordersDelivered: "მიტანილი",
      duration: "ხანგრძლივობა",
      delete: "წაშლა",
      deleteConfirm: "წაიშალოს ეს დახურული მარშრუტი? ეს მოქმედება ვერ გაუქმდება.",
    },
    // Run terminology (P5 Phase 3)
    runs: {
      activeRuns: "აქტიური მარშრუტები",
      pausedRuns: "შეჩერებული მარშრუტები",
      closedRuns: "დახურული მარშრუტები",
      noActiveRuns: "აქტიური მარშრუტები არ არის",
      noActiveRunsDesc: "შექმენით მარშრუტი კურიერებისთვის შეკვეთების გასაგზავნად",
      noPausedRuns: "შეჩერებული მარშრუტები არ არის",
      startRun: "მარშრუტის დაწყება",
      pauseRun: "მარშრუტის შეჩერება",
      resumeRun: "მარშრუტის გაგრძელება",
      closeRun: "მარშრუტის დახურვა",
      copyLink: "ბმულის კოპირება",
      openCourierView: "კურიერის ხედის გახსნა",
      runPaused: "მარშრუტი შეჩერდა",
      runResumed: "მარშრუტი გაგრძელდა",
      runClosed: "მარშრუტი დაიხურა",
      pending: "მოლოდინში",
      moreOrders: "სხვა შეკვეთა",
      noStops: "ამ მარშრუტში გაჩერებები არ არის",
      noExpiry: "ვადის გარეშე",
      expired: "ვადაგასული",
      pause: "პაუზა",
      resume: "განახლება",
      close: "სესიის დახურვა",
      paused: "შეჩერებული",
      closeConfirmDescription: "დარწმუნებული ხართ, რომ გსურთ ამ მარშრუტის დახურვა? ეს მოქმედება ვერ გაუქმდება.",
    },
    noOrdersInSession: "ამ მარშრუტში გაჩერებები არ არის",
  },
  todayBoard: {
    title: "დღევანდელი სამუშაო",
    needsAttention: {
      title: "საჭიროებს ყურადღებას",
      subtitle: "წინა დღეების დაუსრულებელი შეკვეთები",
      ordersLabel: "შეკვეთა",
      outForDelivery: "გზაშია",
      readyNotSent: "მზადაა (არ გაიგზავნა)",
      newBacklog: "ჩამორჩენა",
      empty: "ყველაფერი მოგვარებულია 😊 არ საჭიროებს შემდგომ მოქმედებას.",
    },
    today: {
      title: "დღეს",
      empty: "🪧 ჯერჯერობით ახალი შეკვეთები არ არის. გააგრძელეთ ზედა სექციაში.",
      emptyState: "🪧 ჯერჯერობით ახალი შეკვეთები არ არის. გააგრძელეთ ზედა სექციაში.",
    },
    hideDelivered: "მიტანილების დამალვა",
    lastDelivered: "ბოლო",
    delivered: "მიტანილი",
    noDeliveriesYet: "მიტანა ჯერ არ არის",
    labels: {
      newToday: "ახალი",
      fromBacklog: "ჩამორჩენიდან",
    },
    todaysOrders: "დღევანდელი შეკვეთები",
    todayWorkflow: "დღევანდელი სამუშაო",
    todayDesc: "დღევანდელი აქტიური შეკვეთები",
    workedOnToday: "დღეს დამუშავებული",
    showLess: "ნაკლების ჩვენება",
    stages: {
      new: "ახალი",
      ready: "მზადაა",
      outForDelivery: "გზაში",
      delivered: "მიტანილი",
      failed: "ვერ მიტანილი",
    },
    statuses: {
      new: "ახალი",
      ready: "მზადაა",
      outForDelivery: "გზაში",
      delivered: "მიტანილი",
    },
    actions: {
      process: "მზადაა",
      sendOut: "გაგზავნა მიტანისთვის",
      markDelivered: "მიტანილია",
      confirmDelivered: "მიტანილად დადასტურება",
    },
    quickActions: {
      markStatus: "მონიშნეთ სტატუსი...",
      delivered: "✅ მიტანილია",
      couldNotDeliver: "❌ ვერ მოხერხდა მიტანა",
      onHold: "⏸ შეაჩერე",
      sendOut: "🚀 გაგზავნე",
      process: "⚡ დაამუშავე",
      cancel: "🗑️ გააუქმე",
      deliveredSuccess: "შეკვეთა მიტანილად მონიშნულია",
      failedSuccess: "შეკვეთა ვერ მოხერხდა მიტანად მონიშნულია",
      onHoldSuccess: "შეკვეთა შეჩერებულია",
      sendOutSuccess: "შეკვეთა გაგზავნილია მიტანისთვის",
      processSuccess: "შეკვეთა დამუშავებულია",
      cancelSuccess: "შეკვეთა გაუქმებულია",
    },
    emptyState: "ამ ეტაპზე შეკვეთები არ არის",
    showMore: "+{{count}} მეტი",
    more: "მეტი",
    failed: "ვერ მოხერხდა",
    cancelled: "გაუქმებული",
    noProducts: "პროდუქტები არ არის",
    orderLabel: "შეკვეთა",
    messages: {
      ready: "შეკვეთა მზადაა მიტანისთვის",
    },
    unfinished: {
      title: "წინა დღეების დაუსრულებელი",
      description: "ეს შეკვეთები ჯერ კიდევ ელოდება დასრულებას. დაასრულეთ ჩამორჩენის გასასუფთავებლად.",
      groups: {
        outForDelivery: "მიტანის პროცესში",
        ready: "მზადაა (არ გაგზავნილა)",
        backlog: "ახალი (ჩამორჩენა)",
      },
    },
    bulk: {
      select: "არჩევა",
      cancel: "მზადაა",
      selectAll: "ყველას არჩევა",
      deselectAll: "არჩევის გაუქმება",
      markReady: "მზადაა",
      sendOut: "გაგზავნა",
      markDelivered: "მიტანა",
      readySuccess: "შეკვეთები მზადაა",
      sendOutSuccess: "შეკვეთები გაიგზავნა",
      deliverSuccess: "შეკვეთები მიტანილია",
    },
  },
  needsAttentionTable: {
    order: "შეკვეთა",
    notes: "შენიშვნა",
    reason: "მიზეზი",
    status: "სტატუსი",
    customer: "კლიენტი",
    lastAction: "ბოლო მოქმედება",
    sentOut: "გაგზავნილი",
    markedReady: "მზად არის",
    created: "შექმნილი",
    moreOrders: "სხვა შეკვეთა",
    fallbackOutForDelivery: "ჯერ არ მიუტანია",
    fallbackReady: "ელოდება გაგზავნას",
    fallbackFailed: "მიტანა ვერ მოხერხდა - ხელახლა სცადეთ",
    fallbackAwaitingPayment: "ელოდება გადახდის დადასტურებას",
    fallbackNew: "ელოდება დამუშავებას",
    // Short reason labels for Reason column
    stillOut: "ჯერ გარეთ",
    notDispatched: "არ არის გაგზავნილი",
    failedDelivery: "ჩაიშალა",
    awaitingPayment: "გადახდა ელოდება",
    awaitingProcessing: "დამუშავება ელოდება",
    needsReview: "სჭირდება განხილვა",
  },
  columns: {
    toggle: "სვეტების ჩვენება",
    status: "სტატუსი",
    session: "სესია",
    customer: "კლიენტი",
    productsPrice: "პროდუქტი / ფასი",
    deliveryLog: "ჟურნალი",
    notes: "შენიშვნა",
    reason: "მიზეზი",
    lastAction: "ბოლო მოქმედება",
  },
  todayTable: {
    order: "შეკვეთა",
    status: "სტატუსი",
    customer: "კლიენტი",
    assignedTo: "მინიჭებული",
    customerComments: "კლიენტის კომენტარი",
    productsPrice: "პროდუქტი / ფასი",
    deliveryLog: "ჟურნალი",
    deliveryLogPlaceholder: "შენიშვნის დამატება...",
    clickToAdd: "დააჭირეთ შენიშვნის დასამატებლად",
    notAssigned: "არ არის მინიჭებული",
    noLog: "შენიშვნები არ არის",
    manager: "მენეჯერი",
    courier: "კურიერი",
    system: "სისტემა",
    deliveredFallback: "✓ მიტანილია",
  },
  deliveryLog: {
    title: "ჟურნალი",
    addNote: "შენიშვნის დამატება",
    placeholder: "შეიყვანეთ შენიშვნა...",
    emptyState: "შენიშვნები არ არის",
    roles: {
      manager: "მენეჯერი",
      courier: "კურიერი",
      system: "სისტემა",
    },
  },
  history: {
    title: "ყველა შეკვეთა",
    ordersCount: "{{count}} შეკვეთა",
    viewAll: "ყველა შეკვეთის ნახვა",
  },
  achievements: {
    // Surprise achievements (shown once with pulse)
    recordRevenue: "რეკორდული შემოსავალი. ₾{{amount}}.",
    biggestOrder: "₾{{amount}} - ყველაზე ძვირიანი შეკვეთა.",
    beatYesterday: "{{percent}}%-ით მეტი წინა დღესთან შედარებით.",
    perfectDay: "სრული სამუშაო დღე დასრულდა.",
    milestone: "მიღწევა: შეკვეთა #{{count}}.",
    streak: "{{days}}-დღიანი წარმატებული სერია.",
    // System-status ambient fallbacks
    needAttention: "{{count}} შეკვეთა საჭიროებს ყურადღებას",
    ordersAwait: "{{count}} შეკვეთა რიგშია",
    progressUpdate: "{{delivered}}/{{total}} დასრულებული",
    deliveredToday: "{{delivered}} შეკვეთა დასრულდა დღეს",
    completedRest: "{{count}} სულ დამუშავებული. დღის დასასრული.",
    // Time-based system status (ambient tone)
    morningFresh: "შეკვეთების მართვის სისტემა გააქტიურებულია. დღის დასაწყისი.",
    afternoonSteady: "შეკვეთების ნაკადი სტაბილურია.",
    eveningRest: "საოპერაციო დღე დასრულდა. გადავდივართ ღამის რეჟიმში.",
    nightSleep: "ღამის რეჟიმი. სისტემა ისვენებს.",
  },
  // Day Status Bar - operational summary
  dayStatus: {
    today: "დღეს",
    plannedNoRisk: "{{count}} შეკვეთა დაგეგმილია • 0 რისკის ქვეშ",
    plannedWithRisk: "{{count}} შეკვეთა დაგეგმილია • {{attention}} ყურადღებას საჭიროებს",
    allClear: "ყველაფერი წესრიგშია — მზადაა ახალი შეკვეთებისთვის",
    closure: "დღევანდელი ყველა შეკვეთა დამუშავებულია",
    closureSub: "ხვალ მზადაა",
  },
  // Needs Attention empty state
  needsAttention: {
    allGood: "პრობლემები ამჟამად არ არის",
  },
  // Public Delivery View - Three Section Architecture
  publicDelivery: {
    section: {
      activeWork: "აქტიური სამუშაო",
      completedToday: "დღეს დასრულებული",
      history: "ისტორია",
      historyFooter: "ნაჩვენებია ბოლო 100 მიტანა",
    },
    groupBy: {
      auto: "ავტო",
      area: "რაიონი",
      status: "სტატუსი",
      none: "არცერთი",
    },
    menu: {
      groupBy: "დაჯგუფება",
      expandCompleted: "დასრულებულების გახსნა",
      expandHistory: "ისტორიის გახსნა",
      collapseCompleted: "დასრულებულების დახურვა",
      collapseHistory: "ისტორიის დახურვა",
      refresh: "განახლება",
    },
    statusGroups: {
      ready: "მზადაა აღებისთვის",
      outForDelivery: "მიტანის გზაზე",
      failed: "მიტანა ვერ მოხერხდა",
    },
    emptyActive: "აქტიური შეკვეთები არ არის",
    emptyActiveDesc: "ყველა შეკვეთა მიტანილია ან შეკვეთები არ არის მინიჭებული.",
  },
  errors: {
    invalidLink: "არასწორი ბმული",
    invalidLinkDesc: "მიწოდების ბმულის ფორმატი არ არის სწორი.",
    loadError: "ჩატვირთვის შეცდომა",
    loadErrorDesc: "მიწოდების ინფორმაციის ჩატვირთვა ვერ მოხერხდა. გთხოვთ სცადოთ თავიდან.",
    linkNotFound: "ბმული ვერ მოიძებნა",
    linkNotFoundDesc: "ეს მიწოდების ბმული არ არსებობს.",
    linkExpired: "ბმულის ვადა გასულია",
    linkExpiredDesc: "ამ მიწოდების ბმულის ვადა გასულია და აღარ არის ხელმისაწვდომი.",
    linkInactive: "ბმული არააქტიურია",
    linkInactiveDesc: "ეს მიწოდების ბმული დეაქტივირებულია.",
  },
  actions: {
    retry: "ხელახლა ცდა",
    refreshing: "ახლდება...",
    pullToRefresh: "გადაიდევნეთ განსაახლებლად",
    markOutForDelivery: "მონიშნე მიტანაში",
    markDelivered: "მონიშნე მიტანილად",
    markFailed: "მონიშნე წარუმატებლად",
  },
  planningRadar: {
    future: "მომავალი",
    showFutureTooltip: "დამალული მომავალი შეკვეთების ჩვენება",
    hideFutureTooltip: "მომავალი შეკვეთების დამალვა",
    dueTomorrow: "ხვალ მიტანა",
    dueToday: "დღეს მიტანა",
    overdue: "ვადაგადაცილებული",
    hide: "დამალვა",
    unhide: "ჩვენება",
    orderHidden: "შეკვეთა დამალულია",
    orderRevealed: "შეკვეთა ხილვადია",
    autoRevealed: "ავტო",
    requestedDelivery: "მოთხოვნილი მიტანა",
    selectDate: "აირჩიეთ თარიღი",
    clearDate: "თარიღის გასუფთავება",
    noDate: "თარიღი არ არის",
    scheduledFor: "დაგეგმილია",
    title: "მომავალი მიწოდებები",
    today: "დღეს",
    tomorrow: "ხვალ",
    view: "ნახვა",
    noUpcoming: "მომავალი მიწოდებები არ არის დაგეგმილი",
    moreOrders: "+{{count}} სხვა",
    moreDates: "+{{count}} სხვა თარიღი",
  },
  pinnableWindow: {
    pinWindow: "ფანჯრის მიმაგრება",
    unpinWindow: "ფანჯრის ამოღება",
    minimize: "მინიატურაში შეკუმშვა",
    expand: "გაშლა",
    openFullView: "სრულ ხედში გახსნა",
    close: "დახურვა",
    resetPosition: "პოზიციის აღდგენა",
  },
  payment: {
    title: "გადახდის მეთოდი",
    settingsTitle: "პარამეტრები",
    settingsDesc: "გარე შეკვეთებისთვის გადახდის ვარიანტების კონფიგურაცია",
    deliveryAndPayment: "მიტანა და გადახდა",
    configureExternal: "გარე შეკვეთების პარამეტრების კონფიგურაცია",
    deliveryFee: "მიტანის საფასური",
    addDeliveryFee: "მიტანის საფასურის დამატება",
    addDeliveryDesc: "დაამატეთ მიტანის საფასური შეკვეთის ჯამზე",
    deliveryPrice: "მიტანის ფასი",
    freeDeliveryIf: "უფასო მიტანა თუ...",
    freeDeliveryNote: "დატოვეთ ცარიელი თუ უფასო მიტანა არ გსურთ",
    freeDeliveryPlaceholder: "50₾-ზე მეტი",
    deliveryNote: "მიტანის შენიშვნა",
    deliveryNotePlaceholder: "მაგ: მხოლოდ თბილისში",
    preview: "გამოჩნდება:",
    deliveryLabel: "მიტანა",
    free: "უფასო",
    enableBankTransfer: "გადარიცხვის ჩართვა",
    enableBankTransferDesc: "მომხმარებლებს შეუძლიათ გადაიხადონ საბანკო გადარიცხვით",
    enableBankDesc: "მომხმარებლებს შეეძლებათ გადარიცხვით გადახდა",
    enableCash: "ნაღდი ანგარიშსწორება",
    enableCashDesc: "მომხმარებლებს შეეძლებათ ნაღდით გადახდა",
    bankName: "ბანკის სახელი",
    bankNamePlaceholder: "მაგ: თიბისი ბანკი",
    iban: "IBAN",
    instructions: "ინსტრუქციები (არასავალდებულო)",
    instructionsPlaceholder: "დამატებითი ინსტრუქციები...",
    addBank: "ბანკის დამატება",
    maxBanks: "მაქსიმუმ 4 ბანკი",
    bankRequired: "ბანკის სახელი და IBAN სავალდებულოა",
    invalidIban: "არასწორი IBAN ფორმატი",
    duplicateIban: "ეს IBAN უკვე დამატებულია",
    setDefault: "მთავარად დაყენება",
    defaultMethod: "ნაგულისხმევი მეთოდი",
    cash: "ნაღდი",
    cashOnDelivery: "ნაღდი ანგარიშსწორება",
    bank: "გადარიცხვა",
    bankTransfer: "საბანკო გადარიცხვა",
    bankTransferDesc: "გადარიცხვა მიტანამდე",
    transferAwaitingConfirm: "გადარიცხვა — ელოდება დადასტურებას",
    awaitingPayment: "გადახდის მოლოდინში",
    markAsPaid: "გადახდილად მონიშვნა",
    paymentReceived: "გადახდა მიღებულია",
    confirmPayment: "გადახდის დადასტურება",
    confirmPaymentDesc: "გადახდა დაფიქსირდება და შეკვეთის სტატუსი შეიცვლება ახალი-ზე. დარწმუნებული ხართ?",
    confirmReceived: "გადახდა მიღებულია",
    paymentMethod: "გადახდის მეთოდი",
    bankDetails: "საბანკო რეკვიზიტები",
    reference: "გადარიცხვის აღწერაში მიუთითეთ შეკვეთის ნომერი",
    orderTotal: "შეკვეთის ჯამი",
    atLeastOneMethod: "მინიმუმ ერთი გადახდის მეთოდი უნდა იყოს ჩართული",
  },
  trial: {
    banner: {
      daysRemaining: "თქვენი საცდელი პერიოდი მოქმედებს {{days}} დღე",
      hoursRemaining: "საცდელი პერიოდის {{hours}} საათი დარჩა",
      endsToday: "საცდელი პერიოდი დღეს მთავრდება",
      contactUs: "კითხვები?",
      contactCta: "დაგვიკავშირდით",
      dismiss: "დახურვა",
    },
  },
  trialExpired: {
    title: "საცდელი პერიოდი დასრულდა",
    description:
      "მადლობა OrderFlow-ის გამოცდისთვის. შეკვეთების მართვის გასაგრძელებლად, გთხოვთ აირჩიოთ თქვენთვის შესაფერისი გეგმა.",
    pricing: {
      perMonth: "თვე",
      popular: "პოპულარული",
      starter: {
        name: "სტარტერ",
        description: "იდეალურია დამწყები მცირე ბიზნესებისთვის",
        feature1: "100-მდე შეკვეთა/თვეში",
        feature2: "1 მომხმარებლის ანგარიში",
        feature3: "ელფოსტის მხარდაჭერა",
      },
      growth: {
        name: "ზრდა",
        description: "მზარდი ბიზნესებისთვის მეტი შეკვეთებით",
        feature1: "შეუზღუდავი შეკვეთები",
        feature2: "5-მდე მომხმარებლის ანგარიში",
        feature3: "პრიორიტეტული მხარდაჭერა",
        feature4: "გაფართოებული ანალიტიკა",
      },
    },
    contact: {
      title: "მზად ხართ გასაგრძელებლად?",
      description: "დაგვიკავშირდით გამოწერის გასააქტიურებლად და თქვენი სამუშაო პროცესის შეუფერხებლად გასაგრძელებლად.",
      email: "მოგვწერეთ",
      phone: "დაგვირეკეთ",
    },
    footer: "შექმნილია საქართველოში 🇬🇪 სიყვარულით",
  },
  setupReminder: {
    title: "დაყენების შეხსენებები",
  },
  businessInfo: {
    title: "დაამატეთ ბიზნეს ინფორმაცია",
    description: "დაგვეხმარეთ თქვენი გამოცდილების პერსონალიზებაში",
    addInfo: "დამატება",
    later: "მოგვიანებით",
    saved: "ბიზნეს ინფორმაცია შენახულია",
    modalTitle: "მოგვითხარით თქვენი ბიზნესის შესახებ",
    modalDescription: "ეს გვეხმარება თქვენი გამოცდილების პერსონალიზებაში",
    companyName: "კომპანიის სახელი",
    companyNamePlaceholder: "შეიყვანეთ კომპანიის სახელი",
    businessType: "ბიზნესის ტიპი",
    selectType: "აირჩიეთ ტიპი",
    types: {
      bakery: "საცხობი / საკონდიტრო",
      restaurant: "რესტორანი / კაფე",
      retail: "საცალო ვაჭრობა / მაღაზია",
      delivery: "მიტანის სერვისი",
      other: "სხვა",
    },
  },
  profile: {
    title: "პროფილი",
    subtitle: "მართეთ თქვენი პირადი და ბიზნეს ინფორმაცია",
    fullName: "სახელი და გვარი",
    fullNamePlaceholder: "შეიყვანეთ სახელი",
    companyName: "კომპანიის სახელი",
    businessType: "ბიზნესის ტიპი",
    saved: "პროფილი შენახულია",
    account: "ანგარიში",
    email: "ელ-ფოსტა",
    emailReadOnly: "ელ-ფოსტის შესაცვლელად დაუკავშირდით მხარდაჭერას.",
    changePassword: "პაროლის შეცვლა",
    changePasswordDescription: "დააყენეთ ახალი პაროლი თქვენი ანგარიშისთვის.",
    newPassword: "ახალი პაროლი",
    confirmPassword: "გაიმეორეთ პაროლი",
    passwordChanged: "პაროლი განახლებულია",
    passwordTooShort: "პაროლი უნდა იყოს მინიმუმ 6 სიმბოლო",
    passwordMismatch: "პაროლები არ ემთხვევა",
    dangerZone: "ანგარიშის მოქმედებები",
    signOut: "გასვლა",
    deleteAccount: "ანგარიშის წაშლა",
    deleteConfirmTitle: "ანგარიშის სამუდამოდ წაშლა?",
    deleteConfirmBody: "ეს სამუდამოდ წაშლის თქვენს ანგარიშს, შეკვეთებს, კლიენტებს, პროდუქტებს და დაკავშირებულ მონაცემებს. ეს მოქმედება შეუქცევადია.",
    deleteConfirmType: "დასადასტურებლად ჩაწერეთ {word}",
    deleteConfirmMismatch: "დადასტურების ტექსტი არ ემთხვევა",
    deleted: "ანგარიში წაშლილია",
  },
  quickReply: {
    title: "კლიენტს პასუხი",
    orderLabel: "შეკვეთა",
    template: "შაბლონი",
    channel: "კავშირის მეთოდი",
    messagePreview: "შეტყობინების გადახედვა",
    copyMessage: "კოპირება",
    copyPhone: "კოპირება",
    copied: "დაკოპირდა!",
    openWhatsApp: "WhatsApp-ის გახსნა",
    openViber: "Viber-ის გახსნა",
    openSMS: "SMS გაგზავნა",
    callCustomer: "დარეკვა",
    noPhone: "კლიენტის ტელეფონი არ არის",
    viberHint: "თუ Viber არ იხსნება, დააკოპირეთ შეტყობინება",
    invalidPhoneHint: "ტელეფონის ფორმატი არასწორია",
    useCopyFallback: "ამის ნაცვლად გამოიყენეთ კოპირების ღილაკები",
    preferred: "სასურველი",
    mobileOnly: "ხელმისაწვდომია მობილურზე",
    didYouSend: "გაგზავნეთ?",
    markAsSent: "გაგზავნილად მონიშვნა",
    markedAsSent: "მონიშნულია გაგზავნილად",
    resetToTemplate: "შაბლონზე დაბრუნება",
    menuItem: "სწრაფი პასუხი",
    channels: {
      whatsapp: "WhatsApp",
      viber: "Viber",
      sms: "SMS",
      call: "დარეკვა",
    },
    templates: {
      orderConfirmed: "შეკვეთა დადასტურებულია",
      paymentRequired: "გადახდა საჭიროა",
      paymentConfirmed: "გადახდა მიღებულია",
      outForDelivery: "გზაშია",
      delivered: "ჩაბარებულია",
      needsClarification: "დაზუსტება საჭირო",
    },
    templateMessages: {
      orderConfirmed:
        "გამარჯობა {customerName}! თქვენი შეკვეთა #{orderNumber} დადასტურებულია. შეგატყობინებთ მზადყოფნისას. მადლობა!\n{trackingLink} - {businessName}",
      paymentRequired:
        "გამარჯობა {customerName}! თქვენი შეკვეთა #{orderNumber} მზადაა. ჯამი: {total}₾. გთხოვთ მიუთითოთ საცნობარო ნომერი #{orderNumber} გადახდისას.\n{trackingLink} - {businessName}",
      paymentConfirmed:
        "გამარჯობა {customerName}! შეკვეთა #{orderNumber} გადახდა მიღებულია. თქვენი შეკვეთა მზადდება. მადლობა!\n{trackingLink} - {businessName}",
      outForDelivery:
        "გამარჯობა {customerName}! თქვენი შეკვეთა #{orderNumber} გზაშია! კურიერი მალე მოვა.\n{trackingLink} - {businessName}",
      delivered:
        "გამარჯობა {customerName}! თქვენი შეკვეთა #{orderNumber} ჩაბარებულია. მადლობა რომ გვირჩევთ! - {businessName}",
      needsClarification:
        "გამარჯობა {customerName}! გვაქვს შეკითხვა თქვენი შეკვეთის #{orderNumber} შესახებ. გთხოვთ გადმოგვირეკოთ. - {businessName}",
    },
  },
  preferredChannel: {
    title: "როგორ დაგიკავშირდეთ?",
    whatsapp: "WhatsApp",
    viber: "Viber",
    sms: "SMS",
    call: "სატელეფონო ზარი",
    hint: "ამ არხით გამოგიგზავნით შეკვეთის განახლებებს",
  },
  customers: {
    overview: "მიმოხილვა",
    phone: "ტელეფონი",
    internalNote: "შიდა ჩანაწერი",
    searchPlaceholder: "ძიება სახელით ან ტელეფონით...",
    moduleDisabled: "მომხმარებლების მოდული ჩართული არ არის",
    emptyTitle: "მომხმარებლები ჯერ არ არის",
    emptyDesc: "მომხმარებლები ავტომატურად გამოჩნდებიან შეკვეთების მიღებისას.",
    noResults: "მომხმარებლები ვერ მოიძებნა",
    noResultsDesc: "სცადეთ ძიების პარამეტრების შეცვლა.",
    notFound: "მომხმარებელი ვერ მოიძებნა",
    ordersLabel: "შეკვეთა",
    noDeliveredOrders: "მიტანილი შეკვეთები ჯერ არ არის",
    orderHistory: "შეკვეთების ისტორია",
    lastAddress: "ბოლო მისამართი",
    recentAddresses: "ბოლო მისამართები",
    tableHeaders: {
      namePhone: "მომხმარებელი",
    },
    stats: {
      revenue: "შემოსავალი",
      orders: "შეკვეთები",
      lastOrder: "ბოლო შეკვეთა",
      active: "აქტიური",
      needsAttention: "ყურადღება სჭირდება",
    },
    sections: {
      needsAttention: "ყურადღება სჭირდება",
      needsAttentionDesc: "7+ დღეა არ შეუკვეთია",
      active: "აქტიური",
      activeDesc: "ბოლოს შეუკვეთა",
      top: "საუკეთესო კლიენტები",
      topDesc: "ყველაზე მაღალი შემოსავალი",
      all: "ყველა მომხმარებელი",
      allDesc: "კლიენტების სრული სია",
      daysAgo: "{n}დ წინ",
    },
  },
};
